appendWishlistIcons();
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div)
  oldDiv.text = newDiv;
}

replaceTemplate("wizzy-search-results-product");
replaceTemplate("wizzy-facet-item-common");
replaceTemplate("wizzy-search-wrapper");
replaceTemplate("wizzy-autocomplete-topproducts");
replaceTemplate("wizzy-grid-facet-block");

const addSorting = filter => {

  let newSort = [];
  newSort.push(
    {
      field: "relevance",
      order: "asc"
    },
    {
      field: "sellingPrice",
      order: "asc"
    }),

    filter.sort = newSort
  // console.log("WIZ ADDING NEW SORT", filter.sort);
}

var priceBucket = [
  { from: 0, to: 249 },
  { from: 250, to: 499 },
  { from: 500, to: 999 },
  { from: 1000, to: 1999 },
  { from: 2000, to: 2999 },
  { from: 3000, to: 3999 },
  { from: 4000, to: 4999 },
  { from: 5000, to: 9999 },
  { from: 10000, to: 19999 },
  { from: 20000, to: 29999 },
  { from: 30000, to: 49999 },
  { from: 50000 }
];

const availableSizeStrings = [
  "Newborn",
  "0 to 3M",
  "3 to 6M",
  "6 to 9M",
  "6 to 9 M",
  "9 to 12M",
  "0 to 6M",
  "6 to 12M",
  "0 to 12M",
  "12 to 18M",
  "18 to 24M",
  "12 to 24M",
  "24 to 36M",
  "36 to 48M",
  "48 to 60M",
  "32",
  "32C",
  "34",
  "34C",
  "34D",
  "36",
  "36B",
  "36C",
  "38",
  "38C",
  "38D",
  "40",
  "40C",
  "42",
  "44",
  "5 gm",
  "8 gm",
  "25 gm",
  "30 gm",
  "50 gm",
  "60 gm",
  "75 gm",
  "100 gm",
  "125 gm",
  "175 gm",
  "200 gm",
  "250 gm",
  "400 gm",
  "850 gm",
  "15 ml",
  "30 ml",
  "40 ml",
  "45 ml",
  "50 ml",
  "70 ml",
  "100 ml",
  "120 ml",
  "150 ml",
  "180 ml",
  "200 ml",
  "250 ml",
  "315 ml",
  "150 mm",
  "155 mm",
  "185 mm",
  "480 mm",
  "Free Size",
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "XXXL",
  "6 to 8.9 inches",
  "9 inches and above",
];

// Boosting Collection Pages Sort Order Code Starts
var realPage = 1;
var lastProductId = null;
var boostingDone = false;
var wizzyCollectionProductIds2 = [];
var wizzyCachedFilters = null;
var receivedProductIds = [];
const WIZZY_REAL_PAGE_KEY = "wizzy_realPage";
const WIZZY_LAST_PRODUCT_ID = "wizzy_lastProductId";
const WIZZY_COLLECTION_HANDLE = "wizzy_collectionHandle";
const WIZZY_RECEIVED_PRODUCT_IDS = "wizzy_receivedProductIds";
// Boosting Collection Pages Sort Order Code Ends

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {

      window.wizzyCollectionsSortOrderConfig = {};

      window.wizzyConfig.filters.configs.layout = "v2";

      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.view.templates.facets.gridFilterCommon = "#wizzy-grid-facet-block";
      console.log();
      data.common.lazyDOMConfig.searchInputIdentifiers.push({
        "dom": "input#Search-In-Modal",
        "type": "search"
      });
      window.wizzyConfig['search']['configs']['pagination']['infiniteScrollOffset'] = {
        desktop: 5000,
        mobile: 5000
      };


      data.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";

      data.search.configs.facets.configs.forEach(facet => {
        if (facet.key === "sellingPrice") {
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          facet.key = "product_lowest_variant_price_instock:float";
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          facet.buckets = priceBucket;
        }

        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
        if (facet.key === "product_lowest_variant_price_instock:float") {
          facet.buckets = priceBucket;
        }
        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      });

      data.search.configs.sorts.configs.forEach(sort => {
        if (sort.field === "sellingPrice") {
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          sort.field = "product_lowest_variant_price_instock:float";
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
        }

        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
        if (sort.field === "discountPercentage") {
          sort.field = "product_lowest_variant_discounts_percentage_instock:float";
        }
        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      });

      window.initialiseQueryData();

      return data;

    }, 1

  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {

      console.log("BEFORE_FILTERS_EXECUTED->>>", data.filters);

      if (data.filters.sort && data.filters.sort.length && data.filters.sort[0].field == 'relevance' && !(data.filters.type === "AUTOCOMPLETE_DEFAULT") && window.wizzyConfig.common.isOnCategoryPage === false) {
        addSorting(data.filters);
      }
      // else if(data.filters.sort&&data.filters.sort.length&&data.filters.sort[0].field=='relevance'&&window.wizzyConfig.common.isOnCategoryPage===true&&window.wizzyConfig.common.collectionDefaultSort==='best-selling')
      // {
      //   // console.log("CATEGORY SORT APLLIED", data.filters.sort);
      //   data.filters.sort = [
      //     {field: 'relevance', order: 'asc'},
      //     {field: "product_wizzy-best-selling_sortOrder:float", order: 'asc'},
      //     {field: "sellingPrice", order: "asc"}
      //   ];
      // }
      // else if(data.filters.sort&&data.filters.sort.length&&data.filters.sort[0].field=='relevance'&&window.wizzyConfig.common.isOnCategoryPage===true)
      // {
      //   // console.log("CATEGORY SORT APLLIED", data.filters.sort);
      //   data.filters.sort = [
      //     {field: 'relevance', order: 'asc'},
      //     {field: "product_"+window.wizzyConfig.common.collectionHandle+"_sortOrder:float", order: 'asc'},
      //     {field: "sellingPrice", order: "asc"}
      //   ];
      // }
      else if (
        data.filters.sort &&
        data.filters.sort.length &&
        data.filters.sort[0].field == "relevance" &&
        window.wizzyConfig.common.isOnCategoryPage === true &&
        (String(window.sortSwitchCustom || "").toLowerCase() === "custom" || window.sortSwitchCustom === '')
      ) {
        // console.log("WIZ CATEGORY SORT APLLIED", data.filters.sort);
        var oldSort = data.filters.sort;
        data.filters.sort = [
          // Change done on 23-06-2024 --- Wizzy
          { field: "relevance", order: "asc" },
          { field: "product_sorting_4_custom:float", order: "asc" },
          { field: "product_sorting_3_custom:float", order: "asc" },
          { field: "product_sorting_2_custom:float", order: "asc" },
          { field: "product_sorting_1_custom:float", order: "asc" },
          { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true },
        ].concat(oldSort);
      }
      else if (
        data.filters.sort &&
        data.filters.sort.length &&
        data.filters.sort[0].field == "relevance" &&
        window.wizzyConfig.common.isOnCategoryPage === true &&
        (String(window.sortSwitchCustom || "").toLowerCase() === "default")
      ) {
        // console.log("WIZ CATEGORY SORT APLLIED", data.filters.sort);
        var alreadyAdded = data.filters.sort.some(
          (s) => s.field === "sellingPrice"
        );
        if (!alreadyAdded) {
          var oldSort = data.filters.sort;
          var sellingPriceVariantSort = { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true };
          oldSort.push(sellingPriceVariantSort);
          data.filters.sort = oldSort;
        }
      }

      if (
        data.filters.sort &&
        data.filters.type === "NO_RESULTS_FOUND"
      ) {
        // console.log("WIZ CATEGORY SORT APLLIED", data.filters.sort);
        var noResultsCollectionHandle = data.filters?.categories?.[0] ? data.filters.categories[0] : "all";
        var dynamicSortField = `product_${noResultsCollectionHandle}_sortOrder:float`;

        if (window.noResultsSortSwitchCustom === "Custom" || window.noResultsSortSwitchCustom === '') {
          data.filters.sort = [
            // Change done on 23-06-2024 --- Wizzy
            { field: "relevance", order: "asc" },
            { field: "product_sorting_4_custom:float", order: "asc" },
            { field: "product_sorting_3_custom:float", order: "asc" },
            { field: "product_sorting_2_custom:float", order: "asc" },
            { field: "product_sorting_1_custom:float", order: "asc" },
            { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true },
            { field: "relevance", order: "asc" },
            { field: dynamicSortField, order: "asc" }
          ];
        }
        else if (window.noResultsSortSwitchCustom === "Default") {
          data.filters.sort = [
            { field: "relevance", order: "asc" },
            { field: dynamicSortField, order: "asc" },
            { field: "sellingPrice", order: "asc", isForParent: false, isForVariation: true }
          ];
        }
      }

      let attr = data.filters.attributes;

      for (let key in attr) {
        if (attr.hasOwnProperty(key)) {
          let value = attr[key];
          if (Array.isArray(value)) {
            let decodedArray = value.map(item => decodeURIComponent(item));
            attr[key] = decodedArray;
            // console.log("Key:", key, "Value:", decodedArray);
          } else {
            let decodedValue = decodeURIComponent(value);
            attr[key] = decodedValue;
            // console.log("Key:", key, "Value:", decodedValue);
          }
        }
      }

      if (data.filters.brands?.length) {
        // console.log("brands");
        data.filters.brands = data.filters.brands.map(item => decodeURIComponent(item));
      }
      data.filters.attributeFacetValuesLimit = 150;

      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      const floatKeys = ["product_lowest_variant_price_instock"];

      data.filters.floatAttributes = data.floatAttributes || {};

      floatKeys.forEach((attrKey) => {
        if (data.filters[attrKey]) {
          data.filters.floatAttributes[attrKey] = data.filters[attrKey];
        }
      });

      if (data.filters.attributes) {
        var attrs = data.filters.attributes;

        floatKeys.forEach(key => {
          if (attrs.hasOwnProperty(key)) {
            delete attrs[key];
            const urlParams = new URLSearchParams(window.location.search);

            const gteKey = `fA.${key}.gte[]`;
            const lteKey = `fA.${key}.lte[]`;

            const gte = urlParams.get(gteKey);
            const lte = urlParams.get(lteKey);

            if (gte || lte) {
              const entry = {};
              if (gte) entry.gte = gte;
              if (lte) entry.lte = lte;

              data.filters.floatAttributes[key] = [entry];
              data.filters[key] = [entry];
            }
          }
        });
      }
      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

      return data;

    }, 1

  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      console.log("Wizzy from BEFORE_FILTERS_EXECUTED", data.filters.sort);

      if (window.wizzyConfig.common.isOnCategoryPage) {
        // // data.filters.inStock = ['true', 'false'];
        data.filters.inventorySources = [{ 'key': '73959702750', 'inStock': [true] }];
        //   // console.log("Wizzy Getkeystoremove from JS", data.filters.inventorySources);
        // if (
        //   data.filters.sort &&
        //   data.filters.sort.length &&
        //   data.filters.sort[0].field == "relevance" &&
        //   window.wizzyConfig.common.isOnCategoryPage === true &&
        //   (window.sortSwitchCustom === "Default") && 
        //   typeof window.wizzyCollectionProductIds !== 'undefined'
        // ) {
        //     data.filters.boostGroupIds = window.wizzyCollectionProductIds;
        //   } else if (
        //     data.filters.sort &&
        //     data.filters.sort.length &&
        //     data.filters.sort[0].field === "relevance" &&
        //     window.wizzyConfig.common.isOnCategoryPage === true &&
        //     (window.sortSwitchCustom === "Custom" || window.sortSwitchCustom === '')
        //   ) {
        //   // console.log("<===== ABCD COMING HERE");
        //     data.filters.boostGroupIds = [];
        //   }

        data.filters.boostGroupIds = [];
        data.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;

        if (
          data.filters.sort &&
          data.filters.sort.length &&
          data.filters.sort[0].field == "relevance" &&
          window.wizzyConfig.common.isOnCategoryPage === true &&
          (String(window.sortSwitchCustom || "").toLowerCase() === "default") &&
          typeof window.inStockWizzyCollectionProductIds !== 'undefined'
        ) {
          var hasQueryParams = window.location.search && window.location.search.length > 1;
          var hasAttributes = data.filters.attributes && Object.values(data.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
          var hasFloatAttributes = data.filters.floatAttributes && Object.values(data.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
          var hasBrands = data.filters.brands && data.filters.brands.length > 0;
          var hasSellingPrice = data.filters.sellingPrice && data.filters.sellingPrice.length > 0;
          var hasGenders = data.filters.genders && data.filters.genders.length > 0;
          data.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
          var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasSellingPrice || hasGenders || hasFloatAttributes;
          console.log("<===== Wizzy BOOST BEFORE hasAnyOtherFilterApplied", hasAttributes, hasBrands, hasSellingPrice, hasGenders, hasAnyOtherFilterApplied);
          var productsCount = data.filters?.productsCount ?? 50;
          var currentPage = realPage ?? 1;
          var totalPages = window.wizzyConfig?.pageStore?.searchedResponse?.pages;
          var filtersChanged = hasFilterStateChanged(data.filters);
          wizzyCachedFilters = {
            attributes: deepClone(data.filters.attributes || {}),
            floatAttributes: deepClone(data.filters.floatAttributes || {}),
            brands: deepClone(data.filters.brands || []),
            sellingPrice: deepClone(data.filters.sellingPrice || []),
            genders: deepClone(data.filters.genders || []),
          };
          setCachedFilters(wizzyCachedFilters);
          if (currentPage === 100) {
            data.filters.page = currentPage;
          }
          if (filtersChanged) {
            realPage = 1;
            setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
            setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
            setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
          }
          const currentCollectionHandle =
            data.filters?.categories?.[0] ||
            window.wizzyConfig?.common?.collectionHandle ||
            null;
          if (!hasAnyOtherFilterApplied && realPage < 101 && (typeof totalPages === 'undefined' || totalPages > 1) && !boostingDone) {
            var wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIds.slice(0, 50);
            console.log("<===== Wizzy COMING HERE", wizzyCollectionProductIds1, window.inStockWizzyCollectionProductIdsNew);
            if (typeof window.inStockWizzyCollectionProductIdsNew != "undefined" && window.inStockWizzyCollectionProductIdsNew) {
              wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIdsNew.slice(0, 50);
            }
            data.filters.boostGroupIds = wizzyCollectionProductIds1;
            const cachedCollectionKey = getSessionString(WIZZY_COLLECTION_HANDLE);
            if (cachedCollectionKey !== currentCollectionHandle) {
              setSessionString(WIZZY_COLLECTION_HANDLE, currentCollectionHandle);
              setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
              setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
              setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
            }
          } else if (hasAnyOtherFilterApplied) {
            data.filters.boostGroupIds = [];
          }
          console.log("<===== Wizzy BOOST BEFORE IF", window.inStockWizzyCollectionProductIdsNew, hasAnyOtherFilterApplied, realPage, totalPages, boostingDone, filtersChanged);
          if (typeof window.inStockWizzyCollectionProductIdsNew != "undefined" && window.inStockWizzyCollectionProductIdsNew && !hasAnyOtherFilterApplied && realPage < 101 && realPage > 1 && (typeof totalPages === 'undefined' || totalPages > 1) && !boostingDone) {
            if (data.filters && data.filters.type === "CATEGORY_PAGE" && data.filters.sort && data.filters.sort.length > 0 && data.filters.sort[0].field === "relevance" && window.inStockWizzyCollectionProductIdsNew && window.inStockWizzyCollectionProductIdsNew.length > 0) {
              // wizzyCollectionProductIds = wizzyCollectionProductIds.slice(0, productsCount);
              if (realPage === totalPages + 1) {
                data.filters.page = totalPages + 1;
              }
              // var wizzyCollectionProductIds2 = window.inStockWizzyCollectionProductIdsNew.slice(0, Math.floor(1000 / productsCount) * productsCount);
              // var adjustedLength = Math.floor(window.inStockWizzyCollectionProductIdsNew.length / productsCount) * productsCount;
              // wizzyCollectionProductIds2 = window.inStockWizzyCollectionProductIdsNew.slice(0, adjustedLength);
              wizzyCollectionProductIds2 = window.inStockWizzyCollectionProductIdsNew.slice(0, 2000);
              var start = 0;
              console.log("WIZZY boosting lastProductId", lastProductId, typeof lastProductId);

              if (typeof lastProductId !== "undefined" && lastProductId) {
                var lastIndex = wizzyCollectionProductIds2.indexOf(lastProductId);
                console.log("WIZZY boosting lastIndex", lastIndex);
                if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                  boostingDone = true;
                } else if (lastProductId != wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
                  boostingDone = false;
                }

                if (lastIndex !== -1) {
                  start = lastIndex + 1; // start after the last used product
                }
              } else {
                // fallback to old pagination if no lastProductId available
                start = (currentPage - 1) * productsCount;
              }
              var end = (2 * productsCount) + start;
              console.log("WIZZY boosting start", start, currentPage, end, productsCount);
              var wizzyCollectionBoostedProductIds = wizzyCollectionProductIds2.slice(start, end);
              const remainingIds = window.inStockWizzyCollectionProductIdsNew.length - end;
              var categoriesHandle = data.filters?.categories?.[0] || window.wizzyConfig?.common?.collectionHandle;;
              if (
                categoriesHandle &&
                remainingIds <= 50 &&
                !window.wizzyLazy.loading &&
                !boostingDone &&
                window.wizzyLazy.nextPageToLoad <= window.wizzyLazy.totalPages
              ) {
                console.log("WIZZY boosting next 250 products", categoriesHandle, remainingIds, window.wizzyLazy, boostingDone);
                loadNextInStockBatchIfNeeded(
                  categoriesHandle,
                  50
                );
              }
              if (wizzyCollectionBoostedProductIds.length > 50) {
                wizzyCollectionBoostedProductIds = wizzyCollectionBoostedProductIds.slice(0, 50);
              }
              if (wizzyCollectionBoostedProductIds.length === 0) {
                boostingDone = true;
              }
              console.log("WIZZY boosting", wizzyCollectionProductIds2, start, end, wizzyCollectionBoostedProductIds, boostingDone);
              if (wizzyCollectionBoostedProductIds.length > 0) {
                realPage++;
                // console.log("WIZZY boosting 1", realPage);
                data.filters.boostGroupIds = wizzyCollectionBoostedProductIds;
                if (totalPages) {
                  if (realPage !== totalPages + 2) {
                    data.filters.page = 1;
                  }
                }
                if (wizzyCollectionBoostedProductIds.length < productsCount) {
                  data.filters.productsCount = wizzyCollectionBoostedProductIds.length;
                  // console.log("productsCount ----",data.filters.productsCount);
                }
              } else {
                // data.filters.page = realPage + 1;
                // boostingDone = true;
              }
            } else {
              realPage++; // Because realpage is not updating and same request goes for two times
            }
          } else {
            console.log("WIZZY boosting aaaaaaaa", realPage, data.filters.page, data.filters, hasAnyOtherFilterApplied);
            if (realPage === 1 && !hasAnyOtherFilterApplied) {
              var wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIds.slice(0, 50);
              console.log("<===== Wizzy COMING HERE aaaaaaaa", wizzyCollectionProductIds1, window.inStockWizzyCollectionProductIds, window.inStockWizzyCollectionProductIdsNew);
              if (typeof window.inStockWizzyCollectionProductIdsNew != "undefined" && window.inStockWizzyCollectionProductIdsNew) {
                wizzyCollectionProductIds1 = window.inStockWizzyCollectionProductIdsNew.slice(0, 50);
              }
              data.filters.boostGroupIds = wizzyCollectionProductIds1;
              const cachedCollectionKey = getSessionString(WIZZY_COLLECTION_HANDLE);
              if (cachedCollectionKey !== currentCollectionHandle) {
                setSessionString(WIZZY_COLLECTION_HANDLE, currentCollectionHandle);
                setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
                setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
                setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, []);
              }
            }
            data.filters.page = realPage;
            realPage++;
          }
          setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
        } else if (
          data.filters.sort &&
          data.filters.sort.length &&
          data.filters.sort[0].field === "relevance" &&
          window.wizzyConfig.common.isOnCategoryPage === true &&
          (String(window.sortSwitchCustom || "").toLowerCase() === "custom" || window.sortSwitchCustom === '')
        ) {
          // console.log("<===== ABCD COMING HERE");
          const currentCollectionHandle =
            data.filters?.categories?.[0] ||
            window.wizzyConfig?.common?.collectionHandle ||
            null;
          setSessionString(WIZZY_COLLECTION_HANDLE, currentCollectionHandle);
          setSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
          setSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
          data.filters.boostGroupIds = [];
        }

        if (data.filters.sort &&
          data.filters.sort.length &&
          data.filters.sort[0].field == "sellingPrice") {
          // Solved Sorting Order Issue when Selling Price filter is applied - 31/01/2026
          data.filters.inventorySources = [{ 'key': '73959702750', 'inStock': [true] }];
          // Solved Sorting Order Issue when Selling Price filter is applied - 31/01/2026
        }
      }

      if (data.filters.sort[0].field === "sellingPrice") {
        data.filters.showOOSProductsInOrder = "true";
        var sortOrder = data.filters.sort[0].order;
        data.filters.sort = [{
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          // field: "sellingPrice",
          field: "product_lowest_variant_price_instock:float",
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          order: sortOrder,
        }];
      } else {
        data.filters.showOOSProductsInOrder = "false";
      }

      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      if (data.filters.sort[0].field === "product_lowest_variant_price_instock:float") {
        data.filters.showOOSProductsInOrder = "true";
      } else {
        data.filters.showOOSProductsInOrder = "false";
      }

      if (data.filters.sort[0].field === "discountPercentage") {
        data.filters.sort[0].field = "product_lowest_variant_discounts_percentage_instock:float";
      }
      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

      if (data.filters.type === "AUTOCOMPLETE_DEFAULT") {
        delete data.filters.boostGroupIds;
        data.filters.page = 1;
        data.filters.sort = [
          { "field": "relevance", "order": "asc" },
          { "field": "product_parent-favorites_sortOrder:float", "order": "asc" },
          { "field": "sellingPrice", "order": "asc", "isForParent": false, "isForVariation": true }
        ]
      }

      return data;

    }, 3

  );

  try {
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (data) {
        console.log("Product Array", data);

        data.forEach((product) => {
          if (product.price) product.price = product.price.split(".")[0];
          if (product.sellingPrice)
            product.sellingPrice = product.sellingPrice.split(".")[0];
          // product.name =  "duck duck" +product.name
          if (typeof product.attributes === "undefined") {
            product.attributes = [];
          }
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_vendor") {
              product.vendor = attribute.values[0].value[0];
            }
            if (attribute.id === "product_similar_products_custom" || attribute.id === "product_similar_products_other_brands_custom") {
              product.fabric = attribute.values[0].value[0];
            }
            if (attribute.id === "product_best_seller_tags_custom") {
              product.bestseller = attribute.values[0].value[0];
            }
            if (attribute.id === "product_badge_judgeme") {
              product.judgemereview = attribute.values[0].value[0];
            }
            if (attribute.id === "product_product_type_custom") {
              product.producttype = attribute.values[0].value[0];
            }
            if (attribute.id === "product_select_variant_custom") {
              product.swatchAvailable = true;
              product.swatchURL = product.url + '?&view=wizzy-variant-view';
              var swatchdata = attribute.values[0].value[0].split('||');
              product.swatchCount = swatchdata.length;
              if (product.swatchCount < 2) {
                product.swatchAvailable = false;
              }
            }
            if (attribute.id === "product_select_variant_title_custom") {
              var rawTitle = attribute.values[0].value[0];
              var title = rawTitle.charAt(0) + rawTitle.slice(1).toLowerCase();
              product.swatchTitle = title;
              if (product.swatchCount > 1) {
                product.swatchTitle = product.swatchTitle + 's';
              }
            }
          })
          product.url = product.url.split("?")[0];
          // product.name = product.name.slice(0, 45) + "...";
          product.name = product.name;

          product.shownImages = product.images.slice(0, 4);

          if (Array.isArray(product.swatches)) {
            product.swatches.forEach((swatch) => {
              product.hasPackOf = swatch.key == "product_Pack of";
              product.hasSwatchCount = swatch.values.length > 2 ? swatch.values.length - 2 : false;
              product.totalSwatchCount = swatch.values.length;
              product.avilableLabel = swatch.key.split("_")[1].toLowerCase();
              if (swatch.values.length > 1) {
                product.avilableLabel = product.avilableLabel + "s"
              }
              swatch.values = swatch.values.slice(0, 2);
              swatch.values.forEach((val) => {
                val.swatchValue = val.value;
                val.isSwatch = true;
              })
            })
          }
        })
        return data;

      }); //PRODUCTS_RESULTS_RENDERED
  } catch (e) {
    console.log("after transform wizzy", e)
  }



  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (data) {
      // $(".product-item-title").on("click",function(){
      //   alert("hi")
      // })
      console.log("WIZZY THEIASTICKY SIDEBAR")
      if (window.collectionName) {
        $("#wizzy-collection-title").text(window.collectionName);
        $("#wizzy-collection-title-mob").text(window.collectionName);
      }
      try {
        $('.wizzy-search-filters-left').theiaStickySidebar({
          additionalMarginTop: 125
        });
        // $(document).ready(function() {
        //     $('.wizzy-search-filters-left').theiaStickySidebar();
        // }); 
      } catch (e) {
        console.log(e, "theiaStickySidebar");
      }
      var Swipes = new Swiper('.swiper-container', {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
      // $("body").removeClass('wizzy-facet-selected');
      // if ($(".wizzy-selected-facet-list-item").length > 0) {
      //     $("body").addClass('wizzy-facet-selected');
      // }
      let getswipecount = parseInt(localStorage.getItem('swipecount')) || 0;
      if (getswipecount < 5) {
        $('.wizzy-search-results-list li:first-child .swipe-to-change').css('display', 'flex');
      } else {
        $('.wizzy-search-results-list li:first-child .swipe-to-change').css('display', 'none');
      }
      //re init wishlist code
      $(".wishlist-hero-custom-button").each(function (index, element) {
        let buttonInfo = {};

        buttonInfo['ButtonClassElement'] = "wishlist-hero-custom-button-" + $(element).attr('data-wlh-variantid');
        buttonInfo['ProductId'] = parseInt($(element).attr('data-wlh-variantid'));
        buttonInfo['ProductLink'] = $(element).attr('data-wlh-link');
        buttonInfo['ProductVariantId'] = parseInt($(element).attr('data-wlh-variantid'));
        buttonInfo['ProductPrice'] = parseInt($(element).attr('data-wlh-price'));
        buttonInfo['ProductTitle'] = $(element).attr('data-wlh-name');
        buttonInfo['ProductImage'] = $(element).attr('data-wlh-image');
        buttonInfo['ButtonMode'] = "icon_only";
        buttonInfo['WishlistHash'] = "RYQLDZNW6ltoKbpk";

        window.WishListHero_SDK.InitializeAddToWishListButton(buttonInfo);
      });
      $('.wizzy-result-product').each(function (index) {
        $(this).attr('data-index', index + 1);
      });
      appendWishlistIcons();

      return data;

    }); //PRODUCTS_RESULTS_RENDERED

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED, function (data) {
    // console.log(data.sort,"Before search");
    // if(data.sort&&data.sort.length&&data.sort[0].field=='relevance')
    // {
    addSorting(data);
    // }

    return data;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      document.body.classList.remove('autocompleteOpened');
      var searchBars = document.querySelectorAll('search-form .search__input.field__input');
      if (searchBars.length > 1 && searchBars[1]) {
        searchBars[1].blur();
      }
      if (data.sort && data.sort.length && data.sort[0].field == 'relevance') {
        console.log("WIZ BEFORE_SEARCH_EXECUTED->", data);
        addSorting(data);
      }

      //if (window.innerWidth > 768) {
      var searchfromplp = document.querySelector('#MainContent .shopify-section.section .page-width');
      if (searchfromplp) {
        if (document.querySelector('#MainContent .shopify-section.section .page-width').classList.contains("page-width")) {
          document.querySelector('#MainContent .shopify-section.section .page-width').classList.remove("page-width");
        }
      }
      //}
      $('#Search-In-Modal').val(data.q);
      $('.wizzy-main-content').addClass('page-width');
      $('#wizzy-collection-title').css('display', 'none');
      window.collectionName = null;
      localStorage.setItem("firstLevel", "");
      localStorage.setItem("secondLevel", "");
      localStorage.setItem("thirdLevel", "");
      const breadcrumbsContainer = $(".breadcrumbs");
      if (breadcrumbsContainer.children().length > 0) {
        breadcrumbsContainer.addClass("hide");
      }
      const bannerContainer = $(".collection-banner");
      if (bannerContainer.children().length > 0) {
        bannerContainer.hide();
      }

      var collectionTitleFromPlp = $('#wizzy-collection-title-mob');
      if (collectionTitleFromPlp.length > 0) {
        collectionTitleFromPlp.hide();
      }

      var collectionbannerFromPlp = $('.collection-banner-layout-b-desktop');
      if (collectionbannerFromPlp.length > 0) {
        collectionbannerFromPlp.hide();
      }

      if (data && data.q) {
        var querySuggestions = window.wizzyQueryData;
        let currentQuery = data.q.toLowerCase();
        var currentQueryWithRedirection = querySuggestions.filter(i => i.suggestion === currentQuery);
        if (currentQueryWithRedirection.length > 0 && currentQueryWithRedirection[0].redirectionURL) {
          data.q = "";
          window.location.href = currentQueryWithRedirection[0].redirectionURL;
        }
      }

      data.facets.forEach(facet => {
        if (facet.key === "sellingPrice") {
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          facet.key = "product_lowest_variant_price_instock:float";
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          facet.buckets = priceBucket;
        }

        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
        if (facet.key === "product_lowest_variant_price_instock:float") {
          facet.buckets = priceBucket;
        }
        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      });

      data.attributeFacetValuesLimit = 150;

      console.log("WIZ SORT ADDED?", data);

      document.body.classList.remove('wizzy-swatch-popup-opened');

      return data;
    }, 1);

  try {

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function (payload) {

      if (payload.api === 'search' || payload.api === "filter") {
        var facets = payload?.response?.payload?.facets;
        facets?.forEach((facet) => {
          if (facet.key === "product_color_custom") {
            const facetItem = facet.data;
            facetItem.forEach((item) => {
              //let [haxcode,isURLSwatch]=findHaxCode(item.key);
              var item_key = item.key;
              var formattedKey = item_key.replace(/,/g, '').toLowerCase().replace(/\s+/g, '-');
              var swatch_imag = 'https://cdn.shopify.com/s/files/1/0685/2208/2526/files/' + formattedKey + '.png';
              item.isSwatch = true;
              item.isURLSwatch = true;
              item.isVisualSwatch = true;
              item.swatchValue = swatch_imag;
              item.data = {
                value: item.key,
                swatch: {
                  type: 'visual',
                  value: item.key
                }
              }

            })
          }
          if (facet.key === "sellingPrice") {
            let facetItem = facet.data;
            // console.log("sellingPrice FILTERS ->", facet);

            if (Array.isArray(facetItem)) {
              facet.data = facetItem.filter((item) => {
                // console.log("sellingPrice Item ->", item);
                return item.count > 0;
              });
              // console.log("sellingPrice Filtered Data ->", facet.data);
            } else {
              // console.error("sellingPrice facet.data is not an array:", facetItem);
            }

            // facet.order = 2;
          }

          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          if (facet.key === "product_lowest_variant_price_instock") {
            let facetItem = facet.data;
            // console.log("sellingPrice FILTERS ->", facet);

            if (Array.isArray(facetItem)) {
              facet.data = facetItem.filter((item) => {
                // console.log("sellingPrice Item ->", item);
                return item.count > 0;
              });
              // console.log("sellingPrice Filtered Data ->", facet.data);
            } else {
              // console.error("sellingPrice facet.data is not an array:", facetItem);
            }

            // facet.order = 2;
          }
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

          //below code update size facet option's order
          if (facet.key === "product_size_custom") {
            facet.data.sort((a, b) => {
              const indexA = availableSizeStrings.indexOf(a.key);
              const indexB = availableSizeStrings.indexOf(b.key);

              const adjustedIndexA = indexA === -1 ? Infinity : indexA;
              const adjustedIndexB = indexB === -1 ? Infinity : indexB;

              return adjustedIndexA - adjustedIndexB;
            });
          }

          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
          if (facet.key !== "sellingPrice" && facet.key !== "product_size_custom" && facet.key !== "product_lowest_variant_price_instock") {
            if (Array.isArray(facet.data)) {
              facet.data.sort((a, b) => a.label.localeCompare(b.label));
            }
          }
          // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
        })
      }
      var searchbar = document.getElementById('search_mini_form');



      if (searchbar) {

        searchbar.style.display = "none";

      }
      // if (payload.api === "filter") {
      //   // console.log("BEFORE_RENDER_RESULT_PAYLOAD", payload.response.payload.filters.attributes);
      //   var attributes = payload.response.payload.filters.attributes;
      //   if (attributes) {
      //     if (Object.keys(attributes).length > 0){
      //       Object.keys(attributes).forEach((attributekey) => {
      //         // console.log("BEFORE_RENDER_RESULT_PAYLOAD", attributes[attributekey]);
      //         var allfacets = payload.response.payload.facets;
      //         var attributevalues = attributes[attributekey];
      //         allfacets.forEach((facet) => {
      //           if (attributekey === facet.key) {
      //             // console.log("BEFORE_RENDER_RESULT_PAYLOAD", facet.data);
      //             attributes[attributekey] = attributevalues.filter(attributevalue => {
      //                return facet.data.some(dataItem => dataItem.label === attributevalue);
      //              });
      //              // console.log("BEFORE_RENDER_RESULT AFTER_FILTERING", attributes[attributekey]);
      //           }
      //         });
      //       });
      //     }
      //   }
      // }
      // console.log("BEFORE_RENDER_RESULT", payload);

      if (wizzyConfig.common.isOnCategoryPage === true) {
        if (payload.api === "filter") {
          if (payload.response.payload.filters.categories) {
            if (payload.response.payload.filters.categories[0] === 'strollers-prams') {
              window.wizzyConfig.gridFilters = JSON.parse('{"enabled":true,"filters":[{"key":"sellingPrice","question":"FILTER BY PRICE","after":{"web":6,"mobile":4}},{"key":"brands","question":"FILTER BY BRAND","after":{"web":18,"mobile":12}},{"key":"product_color_custom","question":"FILTER BY COLOR","after":{"web":30,"mobile":20}},{"key":"product_product_type_custom","question":"FILTER BY PRODUCT TYPE","after":{"web":42,"mobile":28}},{"key":"product_folding_mechanism_custom","question":"FILTER BY FOLDING MECHANISM","after":{"web":54,"mobile":36}},{"key":"product_safety_features_custom","question":"FILTER BY SAFETY FEATURES","after":{"web":66,"mobile":44}},{"key":"product_car_seat_compatibility_custom","question":"FILTER BY CAR SEAT COMPATIBILITY","after":{"web":78,"mobile":52}},{"key":"product_suspension_system_custom","question":"FILTER BY SUSPENSION SYSTEM","after":{"web":90,"mobile":60}},{"key":"product_canopy_custom","question":"FILTER BY CANOPY","after":{"web":102,"mobile":68}},{"key":"product_fit_and_adjustability_custom","after":{"web":114,"mobile":76}},{"key":"product_additional_features_custom","after":{"web":126,"mobile":84}},{"key":"product_ease_of_use_custom","after":{"web":138,"mobile":92}}]}');
            }
            else if (payload.response.payload.filters.categories[0] === 'baby-car-seats') {
              window.wizzyConfig.gridFilters = JSON.parse('{"enabled":true,"filters":[{"key":"sellingPrice","question":"FILTER BY PRICE","after":{"web":6,"mobile":4}},{"key":"brands","question":"FILTER BY BRAND","after":{"web":18,"mobile":12}},{"key":"product_color_custom","question":"FILTER BY COLOR","after":{"web":30,"mobile":20}},{"key":"product_ideal_age_custom","question":"FILTER BY IDEAL AGE","after":{"web":42,"mobile":28}},{"key":"product_product_type_custom","question":"FILTER BY PRODUCT TYPE","after":{"web":54,"mobile":36}},{"key":"product_safety_features_custom","question":"FILTER BY SAFETY FEATURES","after":{"web":66,"mobile":44}},{"key":"product_recline_positions_custom","question":"FILTER BY RECLINE POSITIONS","after":{"web":78,"mobile":52}},{"key":"product_type_of_harness_custom","question":"FILTER BY TYPE OF HARNESS","after":{"web":90,"mobile":60}},{"key":"product_certifications_custom","question":"FILTER BY CERTIFICATIONS","after":{"web":102,"mobile":68}},{"key":"product_installation_system_custom","question":"FILTER BY INSTALLATION SYSTEM","after":{"web":114,"mobile":76}},{"key":"product_fit_and_adjustability_custom","question":"FILTER BY FIT AND ADJUSTABILITY","after":{"web":126,"mobile":84}},{"key":"product_additional_features_custom","question":"FILTER BY ADDITIONAL FEATURES","after":{"web":138,"mobile":92}}]}');
            }
            else if (payload.response.payload.filters.categories[0] === 'bouncers-rockers-swings') {
              window.wizzyConfig.gridFilters = JSON.parse('{"enabled":true,"filters":[{"key":"sellingPrice","question":"FILTER BY PRICE","after":{"web":6,"mobile":4}},{"key":"brands","question":"FILTER BY BRAND","after":{"web":18,"mobile":12}},{"key":"product_color_custom","question":"FILTER BY COLOR","after":{"web":30,"mobile":20}},{"key":"product_ideal_age_custom","question":"FILTER BY IDEAL AGE","after":{"web":42,"mobile":28}},{"key":"product_product_type_custom","question":"FILTER BY PRODUCT TYPE","after":{"web":54,"mobile":36}},{"key":"product_type_of_operation_custom","question":"FILTER BY TYPE OF OPERATION","after":{"web":66,"mobile":44}},{"key":"product_entertainment_and_interaction_custom","question":"FILTER BY ENTERTAINMENT AND INTERACTION","after":{"web":78,"mobile":52}},{"key":"product_folding_mechanism_custom","question":"FILTER BY FOLDING MECHANISM","after":{"web":90,"mobile":60}},{"key":"product_safety_features_custom","question":"FILTER BY SAFETY FEATURES","after":{"web":102,"mobile":68}},{"key":"product_recline_positions_custom","question":"FILTER BY RECLINE POSITIONS","after":{"web":114,"mobile":76}},{"key":"product_type_of_harness_custom","question":"FILTER BY TYPE OF HARNESS","after":{"web":126,"mobile":84}},{"key":"product_fit_and_adjustability_custom","question":"FILTER BY FIT AND ADJUSTABILITY","after":{"web":138,"mobile":92}},{"key":"product_sub_category_custom","question":"FILTER BY SUB CATEGORY","after":{"web":150,"mobile":100}}]}');
            }
            else if (payload.response.payload.filters.categories[0] === 'baby-carriers') {
              window.wizzyConfig.gridFilters = JSON.parse('{"enabled":true,"filters":[{"key":"sellingPrice","question":"FILTER BY PRICE","after":{"web":6,"mobile":4}},{"key":"brands","question":"FILTER BY BRAND","after":{"web":18,"mobile":12}},{"key":"product_color_custom","question":"FILTER BY COLOR","after":{"web":30,"mobile":20}},{"key":"product_ideal_age_custom","question":"FILTER BY IDEAL AGE","after":{"web":42,"mobile":28}},{"key":"product_carry_position_custom","question":"FILTER BY CARRY POSITION","after":{"web":54,"mobile":36}},{"key":"product_multi_way_carry_custom","question":"FILTER BY MULTI WAY CARRY","after":{"web":66,"mobile":44}},{"key":"product_safety_features_custom","question":"FILTER BY SAFETY FEATURES","after":{"web":78,"mobile":52}},{"key":"product_fit_and_adjustability_custom","question":"FILTER BY FIT AND ADJUSTABILITY","after":{"web":90,"mobile":60}},{"key":"product_additional_features_custom","question":"FILTER BY ADDITIONAL FEATURES","after":{"web":102,"mobile":68}}]}');
            }
            else if (payload.response.payload.filters.categories[0] === 'tricycles') {
              window.wizzyConfig.gridFilters = JSON.parse('{"enabled":true,"filters":[{"key":"sellingPrice","question":"FILTER BY PRICE","after":{"web":6,"mobile":4}},{"key":"brands","question":"FILTER BY BRAND","after":{"web":18,"mobile":12}},{"key":"product_color_custom","question":"FILTER BY COLOR","after":{"web":30,"mobile":20}},{"key":"product_product_type_custom","question":"FILTER BY PRODUCT TYPE","after":{"web":42,"mobile":28}},{"key":"product_usage_environment_custom","question":"FILTER BY USAGE ENVIRONMENT","after":{"web":54,"mobile":36}},{"key":"product_safety_features_custom","question":"FILTER BY SAFETY FEATURES","after":{"web":66,"mobile":44}},{"key":"product_safety_and_comfort_custom","question":"FILTER BY SAFETY AND COMFORT","after":{"web":78,"mobile":52}},{"key":"product_type_of_wheels_custom","question":"FILTER BY TYPE OF WHEELS","after":{"web":90,"mobile":60}},{"key":"product_fit_and_adjustability_custom","question":"FILTER BY FIT AND ADJUSTABILITY","after":{"web":102,"mobile":68}},{"key":"product_additional_features_custom","question":"FILTER BY ADDITIONAL FEATURES","after":{"web":114,"mobile":76}},{"key":"product_folding_mechanism_custom","question":"FILTER BY FOLDING MECHANISM","after":{"web":126,"mobile":84}}]}');
            }
            else {
              window.wizzyConfig.gridFilters = {};
            }
            if (window.wizzyConfig && window.wizzyConfig.gridFilters && Array.isArray(window.wizzyConfig.gridFilters.filters) && window.wizzyConfig.gridFilters.filters.length > 0) {
              let totalCount = payload.response.payload.total;

              let gridFilters = window.wizzyConfig.gridFilters.filters;

              let lastMobilePosition = gridFilters[gridFilters.length - 1].after.mobile;
              let lastWebPosition = gridFilters[gridFilters.length - 1].after.web;

              let webIncrement = 12;
              let mobileIncrement = 8;

              if (totalCount > lastMobilePosition) {
                let newFilters = [];

                let currentWebPosition = lastWebPosition;
                let currentMobilePosition = lastMobilePosition;

                while (currentMobilePosition < totalCount) {
                  gridFilters.forEach((filter) => {
                    currentWebPosition += webIncrement;
                    currentMobilePosition += mobileIncrement;

                    let newFilter = { ...filter };
                    newFilter.after = {
                      web: currentWebPosition,
                      mobile: currentMobilePosition
                    };

                    newFilters.push(newFilter);
                  });
                }

                window.wizzyConfig.gridFilters.filters = [...gridFilters, ...newFilters];
              }
            }
          }
        }
      } else {
        window.wizzyConfig.gridFilters = {};
      }

      if (window.wizzyConfig.common.isOnCategoryPage === true) {
        // console.log("wiz grid facets", payload.response.payload.facets);
        var facets = payload.response.payload.facets;

        var sortedFacets = [...payload.response.payload.facets];

        sortedFacets.sort(function (a, b) {
          return a.order - b.order;
        });

        // console.log("Wiz DATA FOR sorted array", sortedFacets);

        window.wizzyConfig.gridFilters.enabled = true;
        window.wizzyConfig.gridFilters.filters = [];
        var webP = 6;
        var mobP = 4;

        sortedFacets.forEach((sortedFacet) => {
          if (sortedFacet.data.length > 0) {
            // console.log("WIZZZ", sortedFacet.key);

            var gkey = sortedFacet.key;
            var gquestion = "FILTER BY " + sortedFacet.label.toUpperCase();

            // console.log("WIZZZZ 1", gquestion);

            window.wizzyConfig.gridFilters.filters.push({
              key: gkey,
              question: gquestion,
              after: {
                web: webP,
                mobile: mobP
              }
            });

            webP = webP + 12;
            mobP = mobP + 8;
          }
        });

        if (window.wizzyConfig && window.wizzyConfig.gridFilters && Array.isArray(window.wizzyConfig.gridFilters.filters) && window.wizzyConfig.gridFilters.filters.length > 0) {
          let totalCount = payload.response.payload.total;

          let gridFilters = window.wizzyConfig.gridFilters.filters;

          let lastMobilePosition = gridFilters[gridFilters.length - 1].after.mobile;
          let lastWebPosition = gridFilters[gridFilters.length - 1].after.web;

          let webIncrement = 12;
          let mobileIncrement = 8;

          if (totalCount > lastMobilePosition) {
            let newFilters = [];

            let currentWebPosition = lastWebPosition;
            let currentMobilePosition = lastMobilePosition;

            while (currentMobilePosition < totalCount) {
              gridFilters.forEach((filter) => {
                currentWebPosition += webIncrement;
                currentMobilePosition += mobileIncrement;

                let newFilter = { ...filter };
                newFilter.after = {
                  web: currentWebPosition,
                  mobile: currentMobilePosition
                };

                newFilters.push(newFilter);
              });
            }

            window.wizzyConfig.gridFilters.filters = [...gridFilters, ...newFilters];
          }
        }
      }

      window.wizzyConfig.gridFilters.enabled = false;

      // Boosting Collection Pages Sort Order Code Starts
      var tempPage = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.page;

      if (tempPage &&
        realPage > 1 &&
        payload.response?.payload?.filters?.sort &&
        payload.response.payload.filters.sort.length &&
        payload.response.payload.filters.sort[0].field == "relevance" &&
        window.wizzyConfig.common.isOnCategoryPage === true &&
        (String(window.sortSwitchCustom || "").toLowerCase() === "default")) {
        var tempRealPage = realPage - 1;
        payload.response.payload.filters.page = tempRealPage;
        console.log("wizzy tempRealPage", tempPage, tempRealPage, payload.response.payload);
        payload.response.payload.filters.productsCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;

        var results = payload.response?.payload?.result;

        if (results && results.length > 0) {
          var lastProduct = results.at(-1);
          var lastId = lastProduct?.groupId || lastProduct?.id || null;
          if (lastId) lastProductId = parseInt(lastId);
          if (lastProductId) {
            if (lastProductId === wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
              boostingDone = true;
            } else if (lastProductId != wizzyCollectionProductIds2[wizzyCollectionProductIds2.length - 1]) {
              boostingDone = false;
            }
            setSessionNumber(WIZZY_LAST_PRODUCT_ID, lastProductId);
          }
        }
      }

      if (payload.response?.payload?.filters?.sort &&
        payload.response.payload.filters.sort.length &&
        payload.response.payload.filters.sort[0].field == "relevance" &&
        window.wizzyConfig.common.isOnCategoryPage === true &&
        (String(window.sortSwitchCustom || "").toLowerCase() === "default")) {
        // Solved the duplicate issue for last page
        var results = payload.response?.payload?.result;
        var hasAttributes = payload.response.payload.filters.attributes && Object.values(payload.response.payload.filters.attributes).some(v => Array.isArray(v) && v.length > 0);
        var hasFloatAttributes = payload.response.payload.filters.floatAttributes && Object.values(payload.response.payload.filters.floatAttributes).some(v => Array.isArray(v) && v.length > 0);
        var hasBrands = payload.response.payload.filters.brands && payload.response.payload.filters.brands.length > 0;
        var hasSellingPrice = payload.response.payload.filters.sellingPrice && payload.response.payload.filters.sellingPrice.length > 0;
        var hasGenders = payload.response.payload.filters.genders && payload.response.payload.filters.genders.length > 0;
        var hasAnyOtherFilterApplied = hasAttributes || hasBrands || hasSellingPrice || hasGenders || hasFloatAttributes;
        console.log("Wizzy checking repeated before IF", hasAnyOtherFilterApplied);
        if (results && results.length > 0 && !hasAnyOtherFilterApplied) {
          var pCount = window.wizzyConfig?.search?.configs?.general?.noOfProducts ?? 18;
          var tPCount = payload.response?.payload?.total ?? 0;
          var tPages = Math.ceil(tPCount / pCount);
          if (tempRealPage === tPages) {
            for (var i = results.length - 1; i >= 0; i--) {
              var product = results[i];
              var id = product?.groupId || product?.id || null;

              console.log("Wizzy checking repeated", id, receivedProductIds);

              if (!id) break;

              var strId = String(id);

              // If last product id already exists, remove it
              if (receivedProductIds.includes(strId)) {
                results.splice(i, 1);
              } else {
                // If last id itself is not present, stop checking further
                break;
              }
            }
          }

          results.forEach(function (product) {
            var id = product?.groupId || product?.id || null;
            if (id) {
              receivedProductIds.push(String(id));
            }
          });
        } else {
          receivedProductIds = [];
        }
        setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, receivedProductIds);
      } else {
        receivedProductIds = [];
        setSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS, receivedProductIds);
      }
      // Boosting Collection Pages Sort Order Code Ends

      // console.log("WIZ BEFORE_RENDER_RESULTS", payload);

      return payload;
    });
  } catch (e) {
    console.log("wizzy before render", e)
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      console.log("view_rendered_data->>", data.data.response.payload.filters.page);

      formatSelectedPriceRangeLabels();

      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      formatPriceFacetLabels();
      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

      applyGridFilters();


      $(document).on('click', '.wizzy-grid-filters-box', function () {
        $(this).find('.wizzy-facet-head').removeClass('wizzy-selected-facet');
      });


      gridFiltersToggleOnOverflow();


      var sortOnTop = document.querySelector('.wizzy-sub-most-used-filters .wizzy-sort-wrapper-top');

      if (sortOnTop && !sortOnTop.classList.contains('wizzy-click-listener-attached')) {
        sortOnTop.addEventListener('click', function () {
          var sortWrapper = document.querySelector('.wizzy-common-select-wrapper .wizzy-common-select-selector');
          if (sortWrapper) {
            sortWrapper.click();
          }
        });
        sortOnTop.classList.add('wizzy-click-listener-attached');
      }


      initializeTopFilterBehavior();


      initializeSubMostFiltersForSLP();


      handleSubMostUsedFilters();

      handleQuickFilters();
      updateWizzyQuickFilterBodyClasses();

      adjustFixedPositionElementsOnScroll();



      var totalCount = data?.data?.response?.payload?.total;
      if ($("#product_countTotal").length > 0) {
        $("#product_countTotal").text(totalCount);
        // Boosting Collection Pages Sort Order Code Starts
        if (wizzyConfig.common.isOnCategoryPage === true &&
          (String(window.sortSwitchCustom || "").toLowerCase() === "default")
        ) {
          let inStockCount = window.inStockWizzyCollectionProductIdsNew?.length || 0;
          if (totalCount < 250 && inStockCount > 0 && totalCount > inStockCount) {
            $("#product_countTotal").text(inStockCount);
          }
        }
        // Boosting Collection Pages Sort Order Code Ends
      }

      if (wizzyConfig.common.isOnCategoryPage === false) {
        // Check if the user is on a mobile device
        function isMobileDevice() {
          if (screen.width < 700) return true
          else return false
        }
        $(document).ready(function () {
          var multiplier = isMobileDevice() ? 2 : 3;
          // let threshHold = isMobileDevice() ? 280 : 350;
          let threshHold;
          let divBottomPosition
          $(window).scroll(function () {
            threshHold = $(".wizzy-result-product").height()
            const divElement = document.getElementsByClassName("wizzy-search-results")[0];
            // console.log("divElement",divElement)
            divBottomPosition = divElement.getBoundingClientRect().bottom;
            // console.log("divBottomPosition",divBottomPosition)
            let heightOfdiv = $(".wizzy-search-results").height();
            // console.log("heightOfdiv",heightOfdiv)
            var currentScroll = $(this).scrollTop();
            let countThresh = (currentScroll - $(".wizzy-search-wrapper").position().top) / threshHold;
            // console.log("countThresh ",countThresh);
            //  console.log("threshHold ",threshHold);
            //  console.log("multiplier ",multiplier);
            //    console.log("(Math.floor(countThresh))*multiplier ",(Math.floor(countThresh))*multiplier);

            var productCount = ((Math.floor(countThresh)) * multiplier);
            var totalCount = $(".wizzy-result-product").length;

            // console.log("math floor",(Math.floor(countThresh))*2);
            // console.log("Current Scroll Amount:", currentScroll);
            if (divBottomPosition >= window.innerHeight - (isMobileDevice() ? 400 : 100)) {
              if (productCount > totalCount) $("#product_count_viewed").text(totalCount)
              else $("#product_count_viewed").text(productCount);
              if (productCount > 1) {
                $("#productCount").css('display', 'flex');
                $("#scrolledItemsCount-desk").css('display', 'flex');

              }
              else {
                $("#productCount").hide();
                $("#scrolledItemsCount-desk").hide();
              }
            }
            else {
              $("#product_count_viewed").text(totalCount)
            }


          });


          $('#productCount').click(function (e) {
            e.preventDefault();
            // Set the scroll position of the 'html, body' to 0
            $('html, body').scrollTop(0);
            return false;
          });
          $('#scrolledItemsCount-desk').click(function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
          });
        });
      }

      var filterbtn = document.querySelector('.wizzy-filters-mobile-entry');

      if (filterbtn) {
        filterbtn.addEventListener('click', function () {
          $("body").removeClass('wizzy-facet-selected');
        });
      }

      var filterclrall = document.querySelector('.wizzy-filters-clear-all');

      if (filterclrall) {
        filterclrall.addEventListener('click', function () {
          if (!($("body").hasClass('wizzy-facet-selected'))) {
            $("body").addClass('wizzy-facet-selected');
          }
        });
      }


      handleSwatchClickAndPopupBehavior();

      applyCategoryFilterFromTop();


      if (wizzyConfig.common.isOnCategoryPage === true) {
        console.log("view_rendered_data->>", data);

        // if (window.innerWidth < 768){
        var clearallbtn = document.querySelector('.wizzy-filters-clear-all');
        if (clearallbtn) {
          clearallbtn.addEventListener(('click'), function () {
            data.data.response.payload.filters.page = 1;
            // Boosting Collection Pages Sort Order Code Starts
            realPage = 1;
            setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            // Boosting Collection Pages Sort Order Code Ends
          });
        }
        // }

        var clearallbtn = document.querySelector('.wizzy-search-filters-top .wizzy-filters-clear-all');
        if (clearallbtn) {
          clearallbtn.addEventListener(('click'), function () {
            data.data.response.payload.filters.page = 1;
            // Boosting Collection Pages Sort Order Code Starts
            realPage = 1;
            setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            // Boosting Collection Pages Sort Order Code Ends
          });
        }
        // data.data.response.payload.pages = 1;
      }
      if (data.data.api === "filter") {
        var query = data.data?.response?.payload?.filters?.q;
        if (query) {
          $('.wizzy-main-content').addClass('page-width');
        }
      }
      if (data.data.api === "search") {
        $('#MainContent').addClass('wizzy-main-content');
        if ($('#wizzy-shopify-collection-page-wrapper')) {
          $('#wizzy-shopify-collection-page-wrapper').removeClass("page-width wizzy-main-content")
        }
        $('.wizzy-main-content').addClass('page-width');

        function isSearchPage() {
          // Check if the URL contains '/pages/search?q='
          return window.location.href.indexOf('/pages/search?q=') > -1;
        }

        // Check if the current page is a search page and if the popup has not been shown in this session
        if (isSearchPage() && !sessionStorage.getItem('popupSearchShown')) {
          // Prevent default behavior of page load

          // If the conditions are met, show the popup
          setTimeout(function () {
            $('.floating-box').addClass('left-to-right').css('display', 'block')
          }, 10000);

          // Set item in sessionStorage to indicate that the popup has been shown
          sessionStorage.setItem('popupSearchShown', 'true');

          // Hide the popup after 10 seconds
          setTimeout(function () {
            $('.floating-box').removeClass('left-to-right');
          }, 20000);
        }
      }
      let activeFacet = 'Category';
      if (localStorage.getItem('activeFacet')) {
        activeFacet = localStorage.getItem('activeFacet');

      }
      console.log(activeFacet, '<<======activated');
      $('.wizzy-facet-body').css('display', 'none');
      $(".wizzy-facet-head").removeClass('wizzy-selected-facet');
      $(".wizzy-search-filters-left-wrapper .wizzy-facet-head").each(function (index) {
        var facet_title = $(this).find('.facet-head-title').text();
        if (facet_title == activeFacet) {
          $(this).addClass('wizzy-selected-facet');
          $(this).next('.wizzy-facet-body').css('display', 'block');
        }
      });

      $(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").each((index, element) => {
        let a = $(element).find(".active").length;
        if (a > 0) {
          if ($(element).find(".facet-count-title").length === 0) {
            $(element).find(".facet-head-title").after('<span class="facet-count-title">' + a + '</span>')
          }

        }
        console.log(a) // you can take this length and append it to your desired place.
      });
      var activeFilterCount1 = 0;
      $(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").each((index, element) => {
        var activeFilterCount = $(element).find(".facet-count-title").text();
        var countAsInteger = parseInt(activeFilterCount, 10);
        if (!isNaN(countAsInteger)) {
          activeFilterCount1 += countAsInteger;
        }
      });
      if (activeFilterCount1 > 0) {
        $('.wizzy-filters-mobile-entry .wizzy-filter-mobile-count b').html(activeFilterCount1);
        $('.wizzy-sub-most-used-filters .wizzy-applied-filters-count-top').html('(' + activeFilterCount1 + ')');
      }

      var selectedcolors = document.querySelectorAll('.wizzy-selected-facet-list-item-label .wizzy-facet-item-swatch.facet-visual-swatch');
      console.log("filter", selectedcolors);
      selectedcolors.forEach((selectedcolor) => {
        console.log("filter->", selectedcolor);
        var colorNameElement = selectedcolor.closest('.wizzy-selected-facet-list-item-label').querySelector('.facet-item-label-value');
        var colorName = colorNameElement.lastChild.textContent.trim().toLowerCase().split(' ').join('-');
        console.log("filter->", colorName);
        selectedcolor.style.backgroundColor = "none";
        selectedcolor.style.backgroundImage = `url(https://cdn.shopify.com/s/files/1/0685/2208/2526/files/${colorName}.png)`;
      });

      const selectedFacetItems = document.querySelectorAll('.wizzy-selected-facet-list-item');


      if (selectedFacetItems) {
        selectedFacetItems.forEach(item => {
          const existingSpan = item.querySelector('.facet-item-label-value-id');

          if (!existingSpan) {
            const facetKey = item.getAttribute('data-facetkey');

            if (facetKey === "brands") {
              const newSpan = document.createElement('span');
              newSpan.className = 'facet-item-label-value-id';
              newSpan.textContent = 'Brands :';

              const facetLabel = item.querySelector('.facet-item-label-value');
              facetLabel.insertBefore(newSpan, facetLabel.firstChild);
            }
          }
        });
      }

      var hiddenDivs = document.querySelectorAll("#wizzy-review-hidden");
      hiddenDivs.forEach(function (div) {
        var innerValue = div.innerText;
        var nearestDiv = div.nextElementSibling;

        if (nearestDiv) {
          nearestDiv.innerHTML = innerValue;
          var avgRating = nearestDiv
            .querySelector(".jdgm-prev-badge")
            .getAttribute("data-average-rating");
          avgRating = parseFloat(avgRating).toFixed(1);
          var badgeTextElement = nearestDiv.querySelector(
            ".jdgm-prev-badge__text"
          );
          var avgRattingSpan = null;

          if (badgeTextElement) {
            avgRattingSpan = document.createElement("span");
            avgRattingSpan.className = "avgRating";
            avgRattingSpan.innerText = avgRating;

            var totalreviewSpan = document.createElement("span");
            totalreviewSpan.className = "totalReviews";
            totalreviewSpan.innerText = " (" + badgeTextElement.innerText + ")";

            badgeTextElement.innerText = "";

            badgeTextElement.appendChild(avgRattingSpan);
            badgeTextElement.appendChild(totalreviewSpan);
          }
        }
      });
      //$(".wizzy-search-results-list").find(".wizzy-result-product").eq(0).find(".swipe-to-change").css('display','flex');

      // Boosting Collection Pages Sort Order Code Starts
      if (window.innerWidth > 768) {
        var filterItems = document.querySelectorAll('.wizzy-facet-list-item');

        if (filterItems.length > 0) {
          filterItems.forEach((filterItem) => {
            filterItem.addEventListener('click', function () {
              realPage = 1;
              setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
            });
          })
        }
      }

      var sortItems = document.querySelectorAll('.wizzy-common-select-option');

      if (sortItems.length > 0) {
        sortItems.forEach((soertItem) => {
          soertItem.addEventListener('click', function () {
            realPage = 1;
            setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
          });
        })
      }
      // Boosting Collection Pages Sort Order Code Ends

      const footerElement = document.querySelector(
        '.wizzy-search-results-rendered .section-footer-site-map'
      );

      const offset = footerElement
        ? footerElement.offsetHeight + 2200
        : 5000;

      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: offset,
        mobile: offset
      };

      // Quick Filters Requirement - Custom Clear All button - 05-06-2026
      if (data.data?.response?.payload?.filters?.type === "NO_RESULTS_FOUND") {
        const backButton = document.querySelector(".custom-back-button");
        if (backButton) {
          clearButtonOnNoResultPage();
        }
      }

      updateScrollMarginTop();


      return data;
    })
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {


      if (data.api == "search") {
        if (window.innerWidth < 748) {
          var finding = document.querySelector('.wizzy-search-form-wrapper');
          document.querySelector('.wizzy-search-form-wrapper').classList.remove("mobileTapped");
          var clickable = document.querySelector('.wizzy-search-back');

          clickable.click();
        }
      }

      var query = document.querySelectorAll(".wizzy-search-input")[1].value.toLowerCase();

      if (window.innerWidth < 768) {
        query = document.querySelectorAll(".wizzy-search-input")[3].value.toLowerCase();
      }

      if (query) {
        var querySuggestions = window.wizzyQueryData;
        var newSuggestions = querySuggestions.filter(i => i.searchKey === query);
        newSuggestions.sort((a, b) => a.priority - b.priority);
        if (newSuggestions.length > 0) {
          var categories = [];

          newSuggestions.forEach(suggestion => {
            categories.push({
              value: suggestion.suggestion,
              valueHighlighted: suggestion.valueHighlighted
            });
          });

          data.response.payload.categories = categories;
        }
      }

      // console.log("Wizzy AFTER_Wizzy", data);

      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      if (data.response?.payload?.result) {
        var newResults = data.response.payload.result;
        if (newResults.length > 0) {
          newResults.forEach((result) => {
            var lowestInStockSellingPrice = result.sellingPrice;
            var lowestInStockPrice = result.price;
            var lowestInStockDiscount = result.discount;
            var lowestInStockDiscountPercentage = result.discountPercentage;
            result.attributes.forEach((attribute) => {
              if (attribute.id === "product_lowest_variant_price_instock" && Number.isFinite(attribute.values?.[0]?.value?.[0])) {
                lowestInStockSellingPrice = Math.trunc(attribute.values?.[0]?.value?.[0]) ?? result.sellingPrice;
              }

              if (attribute.id === "product_lowest_variant_compare_at_price_instock" && Number.isFinite(attribute.values?.[0]?.value?.[0])) {
                lowestInStockPrice = Math.trunc(attribute.values?.[0]?.value?.[0]) ?? result.price;
              }

              if (attribute.id === "product_lowest_variant_discounts_instock" && Number.isFinite(attribute.values?.[0]?.value?.[0])) {
                lowestInStockDiscount = attribute.values?.[0]?.value?.[0] ?? result.discount;
              }

              if (attribute.id === "product_lowest_variant_discounts_percentage_instock" && Number.isFinite(attribute.values?.[0]?.value?.[0])) {
                lowestInStockDiscountPercentage = Math.trunc(attribute.values?.[0]?.value?.[0]) ?? result.discountPercentage;
              }
            });
            result.sellingPrice = lowestInStockSellingPrice;
            result.price = lowestInStockPrice;
            result.discount = lowestInStockDiscount;
            result.discountPercentage = lowestInStockDiscountPercentage;
          });
        }
      }
      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026


      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      console.log("WIZ PRODUCTS_CACHED_RESULTS_RENDERED", data);

      document.body.classList.add('wizzy-search-results-rendered');

      try {
        // console.log("cache->", $('.wizzy-search-filters-left'));
        $('.wizzy-search-filters-left').theiaStickySidebar({
          'defaultPosition': 'relative',
          additionalMarginTop: 125
        });
        // $(document).ready(function() {
        //     $('.wizzy-search-filters-left').theiaStickySidebar();
        // }); 
      } catch (e) {
        console.log(e, "theiaStickySidebar");
      }

      if (wizzyConfig.common.isOnCategoryPage === false) {
        if (!document.getElementById('MainContent').classList.contains('page-width')) {
          document.getElementById('MainContent').classList.add('page-width');
        }
      }
      var hiddenDivs = document.querySelectorAll("#wizzy-review-hidden");
      hiddenDivs.forEach(function (div) {
        var innerValue = div.innerText;
        var nearestDiv = div.nextElementSibling;
        if (nearestDiv) {
          nearestDiv.innerHTML = innerValue;
          var avgRating = nearestDiv
            .querySelector(".jdgm-prev-badge")
            .getAttribute("data-average-rating");
          avgRating = parseFloat(avgRating).toFixed(1);
          var badgeTextElement = nearestDiv.querySelector(
            ".jdgm-prev-badge__text"
          );
          var avgRattingSpan = null;
          if (badgeTextElement) {
            avgRattingSpan = document.createElement("span");
            avgRattingSpan.className = "avgRating";
            avgRattingSpan.innerText = avgRating;
            var totalreviewSpan = document.createElement("span");
            totalreviewSpan.className = "totalReviews";
            totalreviewSpan.innerText = " (" + badgeTextElement.innerText + ")";
            badgeTextElement.innerText = "";
            badgeTextElement.appendChild(avgRattingSpan);
            badgeTextElement.appendChild(totalreviewSpan);
          }
        }
      });
      var Swipes = new Swiper('.swiper-container', {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });


      handleSwatchClickAndPopupBehavior();

      applyCategoryFilterFromTop();


      $(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").each((index, element) => {
        let a = $(element).find(".active").length;
        if (a > 0) {
          if ($(element).find(".facet-count-title").length === 0) {
            $(element).find(".facet-head-title").after('<span class="facet-count-title">' + a + '</span>')
          }

        }
        console.log(a) // you can take this length and append it to your desired place.
      });
      var activeFilterCount1 = 0;
      $(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").each((index, element) => {
        var activeFilterCount = $(element).find(".facet-count-title").text();
        var countAsInteger = parseInt(activeFilterCount, 10);
        if (!isNaN(countAsInteger)) {
          activeFilterCount1 += countAsInteger;
        }
      });
      if (activeFilterCount1 > 0) {
        $('.wizzy-filters-mobile-entry .wizzy-filter-mobile-count b').html(activeFilterCount1);
        $('.wizzy-sub-most-used-filters .wizzy-applied-filters-count-top').html('(' + activeFilterCount1 + ')');
      }

      if (wizzyConfig.common.isOnCategoryPage === false) {
        // Check if the user is on a mobile device
        function isMobileDevice() {
          if (screen.width < 700) return true
          else return false
        }
        $(document).ready(function () {
          var multiplier = isMobileDevice() ? 2 : 3;
          // let threshHold = isMobileDevice() ? 280 : 350;
          let threshHold;
          let divBottomPosition
          $(window).scroll(function () {
            threshHold = $(".wizzy-result-product").height()
            const divElement = document.getElementsByClassName("wizzy-search-results")[0];
            // console.log("divElement",divElement)
            divBottomPosition = divElement.getBoundingClientRect().bottom;
            // console.log("divBottomPosition",divBottomPosition)
            let heightOfdiv = $(".wizzy-search-results").height();
            // console.log("heightOfdiv",heightOfdiv)
            var currentScroll = $(this).scrollTop();
            let countThresh = (currentScroll - $(".wizzy-search-wrapper").position().top) / threshHold;
            // console.log("countThresh ",countThresh);
            //  console.log("threshHold ",threshHold);
            //  console.log("multiplier ",multiplier);
            //    console.log("(Math.floor(countThresh))*multiplier ",(Math.floor(countThresh))*multiplier);

            var productCount = ((Math.floor(countThresh)) * multiplier);
            var totalCount = $(".wizzy-result-product").length;

            // console.log("math floor",(Math.floor(countThresh))*2);
            // console.log("Current Scroll Amount:", currentScroll);
            if (divBottomPosition >= window.innerHeight - (isMobileDevice() ? 400 : 100)) {
              if (productCount > totalCount) $("#product_count_viewed").text(totalCount)
              else $("#product_count_viewed").text(productCount);
              if (productCount > 1) {
                $("#productCount").css('display', 'flex');
                $("#scrolledItemsCount-desk").css('display', 'flex');

              }
              else {
                $("#productCount").hide();
                $("#scrolledItemsCount-desk").hide();
              }
            }
            else {
              $("#product_count_viewed").text(totalCount);
              $("#productCount").hide();
              $("#scrolledItemsCount-desk").hide();
            }


          });


          $('#productCount').click(function (e) {
            e.preventDefault();
            // Set the scroll position of the 'html, body' to 0
            $('html, body').scrollTop(0);
            return false;
          });
          $('#scrolledItemsCount-desk').click(function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
          });
        });
      }

      formatSelectedPriceRangeLabels();

      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
      formatPriceFacetLabels();
      // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

      applyGridFilters();

      $(document).on('click', '.wizzy-grid-filters-box', function () {
        $(this).find('.wizzy-facet-head').removeClass('wizzy-selected-facet');
      });

      gridFiltersToggleOnOverflow();

      var sortOnTop = document.querySelector('.wizzy-sub-most-used-filters .wizzy-sort-wrapper-top');

      if (sortOnTop) {
        var sortOptions = document.querySelector('.wizzy-search-wrapper .wizzy-common-select-options');
        if (sortOptions) {
          sortOptions.style.display = "none";
        }
        var sortOptionsOverlay = document.querySelector('.wizzy-common-select-overlay');
        if (sortOptionsOverlay) {
          sortOptionsOverlay.style.display = "none";
        }
        sortOnTop.addEventListener('click', function () {
          var sortWrapper = document.querySelector('.wizzy-common-select-wrapper .wizzy-common-select-selector');
          if (sortWrapper) {
            sortWrapper.click();
          }
        });

        if (!(sortOnTop.classList.contains('wizzy-click-listener-attached'))) {
          sortOnTop.classList.add('wizzy-click-listener-attached');
        }
      }


      initializeTopFilterBehavior();


      initializeSubMostFiltersForSLP();


      handleSubMostUsedFilters();

      handleQuickFilters();

      var facetListTopClosed = document.querySelector('.wizzy-facet-list-top');

      if (facetListTopClosed) {
        facetListTopClosed.innerHTML = '';
        document.body.classList.remove("wizzy-sub-most-used-filters-opened");
      }


      adjustFixedPositionElementsOnScroll();

      // Boosting Collection Pages Sort Order Code Starts
      if (window.wizzyConfig.common.isOnCategoryPage === true &&
        (String(window.sortSwitchCustom || "").toLowerCase() === "default")) {
        realPage = getSessionNumber(WIZZY_REAL_PAGE_KEY, 1);
        lastProductId = getSessionNumber(WIZZY_LAST_PRODUCT_ID, 0);
        wizzyCachedFilters = getCachedFilters();
        receivedProductIds = getSessionStringArray(WIZZY_RECEIVED_PRODUCT_IDS);
      }
      // Boosting Collection Pages Sort Order Code Ends

      updateScrollMarginTop();

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {


      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (x && typeof data.isForDefault !== 'undefined' && data.isForDefault === true) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }

      var totalcount = data?.payload?.products?.total;

      if (totalcount) {
        if (x && totalcount === 1) {
          x.classList.add("wizzy-view-more-hide");
        }
      }

      if (window.innerWidth > 768) {
        setTimeout(function () {
          var announcementBar = document.querySelector('.shopify-section.shopify-section-group-header-group.announcement-bar-section');
          var autocompleteWrapper = document.querySelector('.wizzy-body-end-wrapper');

          // console.log("WIZ autocomplete", announcementBar, autocompleteWrapper);

          if (announcementBar) {
            const announcementHeight = announcementBar.offsetHeight || 0;

            if (autocompleteWrapper) {
              if (announcementHeight > 0 && window.scrollY <= 0) {
                autocompleteWrapper.classList.add('wizzy-has-announcement-bar');
              } else {
                autocompleteWrapper.classList.remove('wizzy-has-announcement-bar');
              }
            }
          }
          console.log("WIZ AUTOCOMPLETE", document.querySelector('.wizzy-autocomplete-wrapper.onLeft'));
        }, 10);

        setTimeout(function () {
          var autocomplete = document.querySelector('.wizzy-autocomplete-wrapper.onLeft');
          var searchBars = document.querySelectorAll('search-form .search__input.field__input');

          if (autocomplete) {
            // document.addEventListener('click', function(event) {
            //     if ((autocomplete.style.display === 'none' || autocomplete.style.display === '') && !(Array.from(searchBars).some(searchBar => document.activeElement === searchBar))) {
            //       console.log("WIZ AUTO", autocomplete.style.display);
            //         document.body.classList.remove('autocompleteOpened');
            //     }
            // });

            autocomplete.addEventListener('click', function () {
              document.body.classList.add('autocompleteOpened');
              if (searchBars.length > 1 && searchBars[1]) {
                searchBars[1].focus();
              }
            });
          }
        }, 10);
      }

      if (typeof data.isForDefault === "undefined") {
        data.payload.others = [];
      }

      return data;
    }
  );

  // Quick Filters Requirement - Custom Clear All button - 05-06-2026
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.EMPTY_RESULTS_RENDERED,
    function (data) {
      console.log("Wizzy EMPTY_RESULTS_RENDERED", data);
      clearButtonOnNoResultPage();

      var quickFilterOptions = document.querySelector('.mobile-stroller-slider');

      if (quickFilterOptions) {
        quickFilterOptions.style.display = 'none';
      }


      return data;
    }
  );

  var searchIcon = document.querySelectorAll('.search-modal__form')[4];
  var searchIconMob = document.querySelectorAll('.search-modal__form')[0];
  searchIcon.addEventListener('click', function (event) {
    var searchInput = document.getElementById('searchInput');
    searchInput.click();

    var searchPage = document.getElementById('search_mini_form');
    searchPage.style.display = 'block';
    searchInput.focus();


  });
  searchIconMob.addEventListener('click', function (event) {
    var searchInput = document.getElementById('searchInput');
    searchInput.click();

    var searchPage = document.getElementById('search_mini_form');
    searchPage.style.display = 'block';
    searchInput.focus();
  });
};

function formatSelectedPriceRangeLabels() {
  const currencySymbol = window.wizzyConfig.store.currency.symbol;
  // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
  // const facetItems = document.querySelectorAll('.wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-facetkey="sellingPrice"] .facet-item-label-value');
  const facetItems = document.querySelectorAll('.wizzy-selected-facet-list .wizzy-selected-facet-list-item[data-facetkey="product_lowest_variant_price_instock"] .facet-item-label-value');
  // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

  if (facetItems && facetItems.length > 0) {
    facetItems.forEach(function (item) {
      let value = item.textContent.trim();

      if (value && value.includes('-')) {
        let [minValue, maxValue] = value.split('-');

        minValue = minValue.trim().replace(currencySymbol, '').replace(/,/g, '');
        maxValue = maxValue.trim().replace(currencySymbol, '').replace(/,/g, '').replace('& Above', '*');

        minValue = minValue.split('.')[0];
        maxValue = maxValue !== '*' ? maxValue.split('.')[0] : '*';

        minValue = Number(minValue).toLocaleString();
        maxValue = maxValue !== '*' ? Number(maxValue).toLocaleString() : '*';

        let formattedMaxValue = maxValue === '*' ? '& Above' : currencySymbol + maxValue.trim();

        let formattedValue = `${currencySymbol}${minValue.trim()} - ${formattedMaxValue}`;

        item.textContent = formattedValue;
      }
    });
  }
}

// New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
function formatPriceFacetLabels() {
  const currencySymbol = window.wizzyConfig.store.currency.symbol;

  const labels = document.querySelectorAll(
    '.facet-body-product_lowest_variant_price_instock .wizzy-facet-range-list-label'
  );

  labels.forEach(label => {
    const textNodes = Array.from(label.childNodes).filter(
      node =>
        node.nodeType === Node.TEXT_NODE &&
        node.textContent.trim()
    );

    textNodes.forEach(node => {
      let value = node.textContent.trim();

      // Skip if currency already exists
      if (value.includes(currencySymbol)) return;

      // Normalize number (keep commas)
      node.textContent = ` ${currencySymbol}${value} `;
    });
  });
}
// New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

function applyGridFilters() {
  var gridFilterOptions = document.querySelectorAll('.wizzy-grid-filters-box .wizzy-facet-list-item');

  if (gridFilterOptions.length > 0) {
    gridFilterOptions.forEach((filterOption) => {
      filterOption.addEventListener('click', function () {
        setTimeout(function () {
          var applyBtn = document.querySelector('.wizzy-apply-all-button');
          if (applyBtn) {
            applyBtn.click();
          }
        }, 100);
      });
    });
  }
}

function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll('.wizzy-grid-filters-box');

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector('.wizzy-facet-body .wizzy-facet-list');
        const toggleBtn = box.querySelector('.wizzy-facet-body .wizzy-toggle-btn');
        const filterOptions = box.querySelector('.wizzy-facet-body');

        if (filterList && toggleBtn && filterOptions && !toggleBtn.classList.contains('wizzy-click-event-attached')) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(getComputedStyle(filterList).lineHeight);
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add('collapsed');
            toggleBtn.classList.add('wizzy-click-event-attached');
            toggleBtn.style.display = 'inline-block';
          } else {
            toggleBtn.style.display = 'none';
          }

          toggleBtn.addEventListener('click', function () {
            if (filterOptions.classList.contains('collapsed')) {
              filterOptions.classList.remove('collapsed');
              filterOptions.classList.add('expanded');
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove('expanded');
              filterOptions.classList.add('collapsed');
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add('wizzy-click-event-attached');
          });
        }
      });
    }
  }
}

function initializeTopFilterBehavior() {
  var filterOnTop = document.querySelector('.wizzy-sub-most-used-filters .wizzy-filters-wrapper-top');

  if (filterOnTop) {
    filterOnTop.addEventListener('click', function () {
      var filterWrapper = document.querySelector('.wizzy-filters-mobile-entry');
      if (filterWrapper) {
        $('.wizzy-search-filters-left-wrapper .wizzy-facet-body').css('display', 'none');
        $(".wizzy-search-filters-left-wrapper .wizzy-facet-head").removeClass('wizzy-selected-facet');
        filterWrapper.click();
        if ($('.wizzy-facet-list-item.active').length > 0) {
          var activeFacet = $('.wizzy-facet-list-item.active').first();
          activeFacet.closest('.wizzy-filters-facet-block').find('.wizzy-facet-head').addClass('wizzy-selected-facet');
          activeFacet.closest('.wizzy-filters-facet-block').find('.wizzy-facet-body').css('display', 'block');
          localStorage.setItem('activeFacet', activeFacet.closest('.wizzy-filters-facet-block').find('.wizzy-facet-head').find(".facet-head-title").text());
        } else {
          $(".wizzy-search-filters-left-wrapper .wizzy-facet-head").first().addClass('wizzy-selected-facet');
          $(".wizzy-search-filters-left-wrapper .wizzy-facet-head").first().next('.wizzy-facet-body').css('display', 'block');
          localStorage.setItem('activeFacet', $(".wizzy-search-filters-left-wrapper .wizzy-facet-head").first().find(".facet-head-title").text());
        }
        console.log("WIZ CLICKED");
      }
    });
  }
}

function initializeSubMostFiltersForSLP() {
  if (wizzyConfig.common.isOnCategoryPage === false) {
    window.submostFilters = 'product_Category_custom,product_sub_category_custom';
  }
}

function handleSubMostUsedFilters() {
  // if (wizzyConfig.common.isOnCategoryPage === true) {
  if (window.submostFilters) {
    if (window.submostFilters != '') {
      $('.wizzy-sub-most-used-filters .wizzy-facet-body').css('display', 'none');
      $(".wizzy-sub-most-used-filters .wizzy-facet-head").removeClass('wizzy-selected-facet');

      var filterKeys = window.submostFilters.split(',');

      var targetElement = document.querySelector('.wizzy-sub-most-used-filters-top');

      if (targetElement) {
        targetElement.innerHTML = '';
      }

      filterKeys.forEach(function (key) {

        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026
        if (key === "sellingPrice") {
          key = "product_lowest_variant_price_instock";
        }
        // New Requirement - Updated - Showing Lowest Priced In Stock Variant Always - 24/02/2026

        var element = document.querySelector('.wizzy-facet-list-block [data-key="' + key + '"]');

        if (element && targetElement) {
          var clone = element.cloneNode(true);
          targetElement.appendChild(clone);
        }
      });

      var facetListTopClosed = document.querySelector('.wizzy-facet-list-top');

      if (facetListTopClosed) {
        if (facetListTopClosed.innerHTML === '') {
          document.body.classList.remove("wizzy-sub-most-used-filters-opened");
        }
      }

      var subMostUsedFiltersHead = document.querySelectorAll('.wizzy-sub-most-used-filters .wizzy-facet-head');
      var selectedFilters = [];

      subMostUsedFiltersHead.forEach((filterHead) => {
        filterHead.addEventListener('click', function () {

          document.body.classList.add("wizzy-sub-most-used-filters-opened");

          // setTimeout(function() {
          //   var activeFilter = localStorage.getItem("activeFacet");

          //   if (activeFilter) {
          //       localStorage.removeItem("activeFacet");
          //   }
          // }, 500);

          var parentBlock = filterHead.closest('.wizzy-filters-facet-block');
          var facetListTop = document.querySelector('.wizzy-facet-list-top');

          setTimeout(function () {
            if (filterHead.classList.contains('wizzy-selected-facet')) {
              parentBlock.style.border = '1px solid #E77A50';
            }

            var facetList = parentBlock.querySelector('.wizzy-facet-list');

            if (facetList) {
              var clone = facetList.cloneNode(true);
              facetListTop.innerHTML = "";
              facetListTop.appendChild(clone);

              var newDiv = document.createElement('div');
              newDiv.className = 'wizzy-facet-list-top-options'; // Wrapper div

              var div1 = document.createElement('div');
              div1.className = 'wizzy-facet-list-top-clear-all';
              div1.innerHTML = 'Clear All';

              var div2 = document.createElement('div');
              div2.className = 'wizzy-facet-list-top-apply-btn';
              div2.innerHTML = 'Apply';

              newDiv.appendChild(div1);
              newDiv.appendChild(div2);
              facetListTop.appendChild(newDiv);

              div1.addEventListener('click', function () {
                // console.log('Wiz Div 1 clicked');
                var activeItems = document.querySelectorAll('.wizzy-facet-list-top .wizzy-facet-list-item.active, .wizzy-facet-list-top .wizzy-facet-list-item.active-for-top');
                selectedFilters.forEach(dataKey => {
                  var originalItem = document.querySelector(`.wizzy-facet-list-item[data-key="${dataKey}"]`);
                  if (originalItem) {
                    originalItem.click();
                  }
                });
                activeItems.forEach(item => {
                  var dataKey = item.getAttribute('data-key');
                  if (selectedFilters.includes(dataKey)) {
                    selectedFilters = selectedFilters.filter(key => key !== dataKey);
                  } else {
                    selectedFilters.push(dataKey);
                  }
                  item.classList.remove('active', 'active-for-top');
                });
                selectedFilters.forEach(dataKey => {
                  var originalItem = document.querySelector(`.wizzy-facet-list-item[data-key="${dataKey}"]`);
                  if (originalItem) {
                    originalItem.click();
                  }
                });
                // selectedFilters = [];
              });

              div2.addEventListener('click', function () {
                // console.log('Wiz Div 2 clicked');
                var applyBtn = document.querySelector('.wizzy-apply-all-button');
                if (applyBtn) {
                  applyBtn.click();
                }
                // selectedFilters.forEach(dataKey => {
                //     var originalItem = document.querySelector(`.wizzy-facet-list-item[data-key="${dataKey}"]`);
                //     if (originalItem) {
                //         originalItem.click();
                //     }
                // });
                selectedFilters = [];

                var subMostUsedFiltersOverlay = document.querySelector('.wizzy-sub-most-used-filters-overlay');
                if (subMostUsedFiltersOverlay) {
                  subMostUsedFiltersOverlay.click();
                }
              });

              // Change done on 23-06-2024 --- Wizzy
              if (facetListTop.classList.contains('wizzy-open-above')) {
                const gap = 5;

                facetListTop.style.top =
                  `-${facetListTop.offsetHeight - gap}px`;
              } else {
                facetListTop.style.top = "55px";
              }
            }

            var subMostUsedFiltersValues = document.querySelectorAll('.wizzy-facet-list-top .wizzy-facet-list-item');

            if (subMostUsedFiltersValues) {
              subMostUsedFiltersValues.forEach(item => {
                item.addEventListener('click', function () {
                  if (!item.classList.contains('active')) {
                    item.classList.toggle('active-for-top');
                  }
                  var dataKey = item.getAttribute('data-key');
                  var originalItem = document.querySelector(`.wizzy-facet-list-item[data-key="${dataKey}"]`);

                  if (originalItem) {
                    originalItem.click();
                  }

                  if (selectedFilters.includes(dataKey)) {
                    selectedFilters = selectedFilters.filter(key => key !== dataKey);
                  } else {
                    selectedFilters.push(dataKey);
                  }

                  if (item.classList.contains('active')) {
                    item.classList.remove('active');
                  }

                  // setTimeout(function(){
                  //   var applyBtn = document.querySelector('.wizzy-apply-all-button');
                  //   if (applyBtn) {
                  //     applyBtn.click();
                  //   }
                  // }, 100);
                });
              });
            }

          }, 0);

          var subMostUsedFiltersOverlay = document.querySelector('.wizzy-sub-most-used-filters-overlay');
          if (subMostUsedFiltersOverlay) {
            subMostUsedFiltersOverlay.style.display = 'block';
            subMostUsedFiltersOverlay.addEventListener('click', function () {
              subMostUsedFiltersOverlay.style.display = 'none';
              $('.wizzy-facet-body').css('display', 'none');
              $(".wizzy-facet-head").removeClass('wizzy-selected-facet');
              parentBlock.style.border = '1px solid #f7f4ef';
              facetListTop.innerHTML = '';
              document.body.classList.remove("wizzy-sub-most-used-filters-opened");

              selectedFilters.forEach(dataKey => {
                var originalItem = document.querySelector(`.wizzy-facet-list-item[data-key="${dataKey}"]`);
                if (originalItem) {
                  originalItem.click();
                }
              });
              selectedFilters = [];
            });
          }

          setTimeout(function () {
            var SubMostUsedPopup = document.querySelector('.wizzy-facet-list-top .wizzy-facet-list');
            console.log("WIZ SUB MOST POPUP", SubMostUsedPopup);
            if (SubMostUsedPopup) {
              console.log("WIZ SUB HEIGHT", SubMostUsedPopup.scrollHeight, SubMostUsedPopup.clientHeight);
              if (SubMostUsedPopup.scrollHeight > SubMostUsedPopup.clientHeight) {
                SubMostUsedPopup.style.overflowY = 'scroll'; // Enable inner scroll if content overflows
              } else {
                SubMostUsedPopup.style.cssText = 'overflow: hidden !important;';
              }
            }
          }, 100);
        });
      });

      $(".wizzy-sub-most-used-filters-top .wizzy-filters-facet-block").each((index, element) => {
        let a = $(element).find(".active").length;
        if (a > 0) {
          $(element).addClass("wizzy-top-filters-active");
        }
      });
    }
  }
  // }
}

// Change done on 23-06-2024 --- Wizzy
function adjustFixedPositionElementsOnScroll() {
  var yOffsetThreshold = window.wizzyConfig.common.isOnCategoryPage ? 226 : 119;

  function shouldOpenAbove(parentDiv) {
    if (window.innerWidth > 768 || !parentDiv) {
      return false;
    }

    const rect = parentDiv.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;

    // Hardcoded required dropdown height
    const requiredSpace = (window.innerHeight * 0.21) +
      37 +
      (5 * parseFloat(getComputedStyle(document.documentElement).fontSize));

    return spaceBelow < requiredSpace;
  }

  function handleFixedPositionElements() {
    const parentDiv = document.querySelector('.wizzy-sub-most-used-filters');
    const listDiv = document.querySelector('.wizzy-facet-list-top');
    const sortOptionDiv = document.querySelector('.wizzy-search-sort-wrapper');
    var topSmartBannerDiv = document.querySelector('#smart-banner');
    var smartBannerHeight = 0;

    if (topSmartBannerDiv) {
      smartBannerHeight = topSmartBannerDiv.getBoundingClientRect()?.height;
    }

    if (!parentDiv) return;

    const subMostUsedFilterBottomPosition = parentDiv.getBoundingClientRect()?.bottom;
    const openAbove = shouldOpenAbove(parentDiv);

    // List filter handling
    if (listDiv && subMostUsedFilterBottomPosition) {
      if ((subMostUsedFilterBottomPosition - smartBannerHeight) <= 114) {
        listDiv.classList.add('wizzy-filters-list-fixed-top');
      } else {
        listDiv.classList.remove('wizzy-filters-list-fixed-top');
      }

      if (openAbove) {
        listDiv.classList.add('wizzy-open-above');
      } else {
        listDiv.classList.remove('wizzy-open-above');
      }
    }

    // Sort option handling
    if (sortOptionDiv && subMostUsedFilterBottomPosition) {
      if ((subMostUsedFilterBottomPosition - smartBannerHeight) <= 114) {
        const currentWidth = sortOptionDiv.offsetWidth;
        sortOptionDiv.style.width = `${currentWidth}px`;
        sortOptionDiv.classList.add('wizzy-sort-options-fixed-top');
      } else {
        sortOptionDiv.classList.remove('wizzy-sort-options-fixed-top');
        sortOptionDiv.style.width = '50%';
      }

      if (openAbove) {
        sortOptionDiv.classList.add('wizzy-open-above');
      } else {
        sortOptionDiv.classList.remove('wizzy-open-above');
      }
    }
  }

  // Initial execution
  handleFixedPositionElements();

  // Scroll handling
  window.addEventListener('scroll', handleFixedPositionElements, { passive: true });

  // Resize handling
  window.addEventListener('resize', handleFixedPositionElements);
}

// Change done on 23-06-2024 --- Wizzy
function handleSwatchClickAndPopupBehavior() {
  var swatchoptions = document.querySelectorAll('.wizzy-swatch-option');

  if (swatchoptions.length > 0) {
    swatchoptions.forEach(swatch => {

      // Prevent duplicate binding when function is called multiple times
      if (swatch.dataset.wizzySwatchBound === 'true') {
        return;
      }

      swatch.dataset.wizzySwatchBound = 'true';

      swatch.addEventListener('click', function (e) {
        e.preventDefault();

        // console.log('Wizzy Swatch click - swatch clicked');

        const popup = swatch.nextElementSibling;

        if (!popup) {
          // console.error('Wizzy Swatch click - popup sibling not found');
          return;
        }

        const content = popup.nextElementSibling;

        if (!content) {
          // console.error('Wizzy Swatch click - content sibling not found');
          return;
        }

        const url = popup.textContent.trim();

        // console.log('Wizzy Swatch click - fetching URL:', url);

        fetch(url)
          .then(response => response.text())
          .then(data => {
            // console.log('Wizzy Swatch click - fetch success');

            content.innerHTML = data;

            content.style.display = 'block';
            content.style.opacity = '1';
            content.style.zIndex = 10;

            // console.log(
            //   'Wizzy Swatch click - HTML inserted. Close icons:',
            //   content.querySelectorAll('.swatch-close-icon').length
            // );

            // console.log(
            //   'Wizzy Swatch click - HTML inserted. Swipers:',
            //   content.querySelectorAll('.mySwiper').length
            // );

            // Bind close icons AFTER HTML is inserted
            const swatchCloseIcons = content.querySelectorAll('.swatch-close-icon');

            swatchCloseIcons.forEach(icon => {

              if (icon.dataset.wizzyBound === 'true') {
                return;
              }

              icon.dataset.wizzyBound = 'true';

              icon.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();

                // console.log('Wizzy Swatch click - close icon clicked');

                document.querySelector('.wizzy-swatch-bg-overlay')?.click();
              });
            });

            // Initialize swiper AFTER HTML is inserted
            const swiperElement = content.querySelector('.mySwiper');

            if (swiperElement) {
              // console.log('Wizzy Swatch click - initializing swiper');

              try {
                new Swiper(swiperElement, {
                  slidesPerView: "auto",
                  speed: 500,

                  followFinger: true,

                  touchRatio: 1,

                  resistanceRatio: 0.85,
                  touchEventsTarget: 'wrapper',
                  watchSlidesProgress: false,
                  loop: false,
                  freeMode: true,
                  navigation: {
                    nextEl: content.querySelector('.swiper-button-next'),
                    prevEl: content.querySelector('.swiper-button-prev'),
                  },
                });

                // console.log('Wizzy Swatch click - swiper initialized');
              } catch (err) {
                // console.error('Wizzy Swatch click - swiper init failed', err);
              }
            } else {
              // console.warn('Wizzy Swatch click - no swiper element found');
            }
          })
          .catch(error => {
            // console.error('Wizzy Swatch click - fetch failed', error);
          });

        var bgoverlay = document.querySelector('.wizzy-swatch-bg-overlay');

        if (bgoverlay) {
          bgoverlay.style.display = 'block';
          bgoverlay.style.opacity = '1';
        }

        document.body.classList.add("wizzy-swatch-popup-opened");
      });
    });

    // Bind overlay click ONLY ONCE
    const bgoverlay = document.querySelector('.wizzy-swatch-bg-overlay');

    if (bgoverlay && !bgoverlay.dataset.wizzyBound) {

      bgoverlay.dataset.wizzyBound = 'true';

      bgoverlay.addEventListener('click', function () {

        // console.log('Wizzy Swatch click - overlay clicked');

        var swatchcontent = document.querySelectorAll('.wizzy-swatch-content');

        swatchcontent.forEach(swatch => {
          swatch.classList.remove('active');
          swatch.style.opacity = '0';
          swatch.style.display = 'none';
          swatch.style.zIndex = 0;
          swatch.innerHTML = "";
          swatch.removeAttribute('style');
        });

        bgoverlay.style.display = 'none';
        bgoverlay.style.opacity = '0';
        bgoverlay.removeAttribute('style');

        document.body.classList.remove("wizzy-swatch-popup-opened");
      });
    }

    // Bind content click ONLY ONCE
    document.querySelectorAll('.wizzy-swatch-content').forEach(content => {

      if (content.dataset.wizzyBound === 'true') {
        return;
      }

      content.dataset.wizzyBound = 'true';

      content.addEventListener('click', function (event) {
        const target = event.target.closest('a, .swatch-close-icon');

        if (
          !target ||
          (
            !target.classList.contains('product-card') &&
            !target.classList.contains('swatch-close-icon')
          )
        ) {
          event.preventDefault();
        }
      });
    });
  }
}

function saveWizzyQuickFilterScrollPosition() {
  wizzyQuickFilterScrollState.pending = true;
  wizzyQuickFilterScrollState.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
  wizzyQuickFilterScrollState.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  wizzyQuickFilterScrollState.expiresAt = Date.now() + 10000;
}

function restoreWizzyQuickFilterScrollPosition() {
  if (!wizzyQuickFilterScrollState.pending) return;
  if (Date.now() > wizzyQuickFilterScrollState.expiresAt) {
    wizzyQuickFilterScrollState.pending = false;
    return;
  }

  var scrollX = wizzyQuickFilterScrollState.x;
  var scrollY = wizzyQuickFilterScrollState.y;
  wizzyQuickFilterScrollState.pending = false;

  requestAnimationFrame(function () {
    window.scrollTo(scrollX, scrollY);

    setTimeout(function () {
      window.scrollTo(scrollX, scrollY);
    }, 50);
  });
}

function handleQuickFilters() {
  if (wizzyConfig.common.isOnCategoryPage === true) {
    if (window.quickFilters) {
      if (window.quickFilters != '') {
        var wrappers = document.querySelectorAll('.wizzy-quick-filter-slides');
        if (!wrappers.length) return;

        var filterKey = window.quickFilters;

        var filterElement = document.querySelector('.wizzy-facet-list-block [data-key="' + filterKey + '"]');

        // console.log("Wizzy Quick Filters filterElement", filterElement);
        if (!filterElement) return;

        var filterValues = filterElement.querySelectorAll('.wizzy-facet-list-item');

        // console.log("Wizzy Quick Filters filtervalues", filterValues);

        var originalTypes = [];

        filterValues.forEach(value => {
          var title = value.title;

          if (title) {
            originalTypes.push(title);
          }
        });

        function cleanFilterTitle(type) {
          return type.replace(/[\[\]"]/g, '');
        }

        function getActiveTypes() {
          var facetActiveTypes = Array.from(filterElement.querySelectorAll('.wizzy-facet-list-item.active'))
            .map((value) => cleanFilterTitle(value.title || ''))
            .filter(Boolean);

          // Sort by click order: most recently clicked active filter comes first
          var clickOrder = window.wizzyQuickFilterClickOrder || [];
          var ordered = clickOrder.filter((t) => facetActiveTypes.includes(t));
          var rest = facetActiveTypes.filter((t) => !ordered.includes(t));
          return [...ordered, ...rest];
        }

        function renderSlides(wrapper, activeTypes = []) {
          wrapper.innerHTML = '';

          let activeTypeSet = new Set(activeTypes);
          let seen = new Set();
          let uniqueTypes = originalTypes.filter(type => {
            const cleaned = cleanFilterTitle(type);
            if (seen.has(cleaned)) return false;
            seen.add(cleaned);
            return true;
          }).map(cleanFilterTitle);

          if (activeTypes.length) {
            uniqueTypes = [
              ...activeTypes.filter((type) => uniqueTypes.includes(type)),
              ...uniqueTypes.filter((type) => !activeTypeSet.has(type))
            ];
          }

          function handleizeQuickFilterText(value) {
            return String(value || '')
              .trim()
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '_')
              .replace(/^_+|_+$/g, '');
          }

          function getQuickFilterCollectionSlug(wrapper) {
            const collectionHandle =
              wrapper.dataset.collectionHandle ||
              window.wizzyConfig?.common?.collectionHandle ||
              (window.location.pathname.includes('/collections/')
                ? window.location.pathname.split('/collections/')[1].split('/')[0]
                : '');

            return handleizeQuickFilterText(collectionHandle);
          }

          function getQuickFilterImageSlug(type, wrapper) {
            const collectionSlug = getQuickFilterCollectionSlug(wrapper);
            let handle = handleizeQuickFilterText(type).replace(/_qf$/, '');

            if (collectionSlug && !handle.startsWith(`${collectionSlug}_`)) {
              handle = `${collectionSlug}_${handle}`;
            }

            return `${handle}_qf`;
          }

          // Supported image extensions
          const quickFilterImageBaseUrl = 'https://cdn.shopify.com/s/files/1/0685/2208/2526/files/';
          const quickFilterFallbackImage = 'https://cdn.shopify.com/s/files/1/0685/2208/2526/files/Quick-filter-Icons_Placeholder.jpg?v=1781077281';
          const quickFilterImageExtensions = ['jpg', 'png', 'gif', 'webp'];

          function getQuickFilterCachedImage(slug) {
            try {
              return sessionStorage.getItem(`quick-filter-image:${slug}`);
            } catch (error) {
              return null;
            }
          }

          function setQuickFilterCachedImage(slug, url) {
            try {
              sessionStorage.setItem(`quick-filter-image:${slug}`, url);
            } catch (error) {
              // Ignore storage errors. The image resolver still works without cache.
            }
          }

          function resolveQuickFilterImage(slug, extensionIndex = 0) {
            const cachedUrl = getQuickFilterCachedImage(slug);

            if (cachedUrl) {
              return Promise.resolve(cachedUrl);
            }

            if (extensionIndex >= quickFilterImageExtensions.length) {
              setQuickFilterCachedImage(slug, quickFilterFallbackImage);
              return Promise.resolve(quickFilterFallbackImage);
            }

            const imageUrl = `${quickFilterImageBaseUrl}${slug}.${quickFilterImageExtensions[extensionIndex]}?v=${Date.now()}`;

            return new Promise((resolve) => {
              const preloadImage = new Image();

              preloadImage.onload = function () {
                setQuickFilterCachedImage(slug, imageUrl);
                resolve(imageUrl);
              };

              preloadImage.onerror = function () {
                resolve(resolveQuickFilterImage(slug, extensionIndex + 1));
              };

              preloadImage.src = imageUrl;
            });
          }

          function createQuickFilterImage(slug, cleanType) {
            return `
              <img
                class="quick-filter-img"
                src="${quickFilterFallbackImage}"
                alt="${cleanType}"
                data-slug="${slug}"
                width="100%"
                height="100%"
                loading="eager"
                decoding="async"
              />
            `;
          }

          function showQuickFilterImage(image, imageUrl) {
            const imageContainer = image.closest('.bg-add-img');
            let hasFinished = false;

            function finishLoading() {
              if (hasFinished) return;
              hasFinished = true;
              image.classList.add('is-loaded');
              imageContainer?.classList.remove('is-loading');
            }

            function loadImage(url, useFallbackOnError) {
              function cleanup() {
                image.removeEventListener('load', handleLoad);
                image.removeEventListener('error', handleError);
              }

              function handleLoad() {
                cleanup();
                finishLoading();
              }

              function handleError() {
                cleanup();

                if (useFallbackOnError && url !== quickFilterFallbackImage) {
                  loadImage(quickFilterFallbackImage, false);
                  return;
                }

                // Do not leave a permanent shimmer if even the fallback fails.
                finishLoading();
              }

              image.addEventListener('load', handleLoad);
              image.addEventListener('error', handleError);

              if (image.src !== url) {
                image.src = url;
              }

              // Cached images may already be complete before the load listener runs.
              if (image.complete) {
                if (image.naturalWidth > 0) {
                  handleLoad();
                } else {
                  handleError();
                }
              }
            }

            loadImage(imageUrl, true);
          }

          function loadQuickFilterImages(wrapper) {
            wrapper.querySelectorAll('.quick-filter-img[data-slug]').forEach((image) => {
              const slug = image.dataset.slug;

              resolveQuickFilterImage(slug).then((imageUrl) => {
                if (!image.isConnected || image.dataset.slug !== slug) return;
                showQuickFilterImage(image, imageUrl);
              });
            });
          }

          uniqueTypes.forEach((type) => {
            const cleanType = cleanFilterTitle(type);
            const slug = getQuickFilterImageSlug(cleanType, wrapper);
            const isActive = activeTypeSet.has(cleanType) ? 'active' : '';

            wrapper.innerHTML += `
              <div class="swiper-slide stroller-category ${isActive}" data-type="${cleanType}">
                <div class="main-type">
                  <div class="bg-add">
                    <div class="bg-add-img is-loading">
                      ${createQuickFilterImage(slug, cleanType)}
                    </div>
                    <span class="checkmark">
                 
                      <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M8.75 0.75L2.78374 6.75L0.75 4.70476" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  </div>
                  <h4>${cleanType}</h4>
                </div>
              </div>
            `;
          });

          loadQuickFilterImages(wrapper);

          var slider = wrapper.closest('.wizzy-quick-filter-slider');
          if (slider) {
            if (slider.wizzyQuickFilterSwiper) {
              slider.wizzyQuickFilterSwiper.destroy(true, true);
            }

            slider.wizzyQuickFilterSwiper = new Swiper(slider, {
              slidesPerView: 4.5,
              spaceBetween: 12,
              roundLengths: true,
              watchOverflow: true,
              observer: true,
              observeParents: true,
              freeMode: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              breakpoints: {
                769: {
                  slidesPerView: 'auto',
                  spaceBetween: 30,
                }
              }
            });
          }

        }

        wrappers.forEach((wrapper) => {
          renderSlides(wrapper, getActiveTypes());
        });

        // Re-attach the Wizzy category filter logic after all quick filter wrappers are rendered.
        if (typeof applyCategoryFilterFromTop === 'function') {
          applyCategoryFilterFromTop();
        }


      }
    }
  }
}

function updateWizzyQuickFilterBodyClasses() {
  if (!document.body) return;

  var hasMerchBanner = !!document.querySelector('.merch-banner-section');
  var hasMerchBannerDestop = !!document.querySelector('.merch-banner-wrapper--desk');
  var hasMerchBannerMobile = !!document.querySelector('.merch-banner-wrapper--mob');
  var hasQuickFilterDesktop = !!document.querySelector('.quick_filter_desktop');
  var hasQuickFilterStripDesktop = !!document.querySelector(
    '.quick-filter-strip-desktop .collection-strip-banner img, .quick-filter-strip-desktop .collection-strip-banner source[srcset]'
  );
  var bodyLayoutClasses = [
    'wizzy-has-merch-banner-section',
    'wizzy-no-merch-banner-section',
    'wizzy-has-quick-filter-desktop',
    'wizzy-quick-filter-with-strip-desktop',
    'wizzy-quick-filter-only-desktop',
    'wizzy-merch-banner-quick-filter-with-strip',
    'wizzy-merch-banner-quick-filter-only',
    'wizzy-no-merch-banner-quick-filter-with-strip',
    'wizzy-no-merch-banner-quick-filter-only',
    'wizzy-merch-banner-only-mobile-quick-filter-with-strip',
    'wizzy-merch-banner-only-desktop-quick-filter-with-strip'
  ];

  document.body.classList.remove(...bodyLayoutClasses);

  if (!hasQuickFilterDesktop) return;

  if (hasMerchBanner && hasMerchBannerDestop && hasMerchBannerMobile && hasQuickFilterStripDesktop) {
    document.body.classList.add('wizzy-merch-banner-quick-filter-with-strip');
  } else if (hasMerchBanner && hasMerchBannerMobile) {
    document.body.classList.add('wizzy-merch-banner-only-mobile-quick-filter-with-strip');
  } else if (hasMerchBanner && hasMerchBannerDestop && hasQuickFilterStripDesktop) {
    document.body.classList.add('wizzy-merch-banner-only-desktop-quick-filter-with-strip');
  } else if (hasMerchBanner) {
    document.body.classList.add('wizzy-merch-banner-only-quick-filter-not');
  } else if (hasQuickFilterStripDesktop) {
    document.body.classList.add('wizzy-no-merch-banner-quick-filter-with-strip');
  } else {
    document.body.classList.add('wizzy-no-merch-banner-quick-filter-only');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateWizzyQuickFilterBodyClasses);
} else {
  updateWizzyQuickFilterBodyClasses();
}

function applyCategoryFilterFromTop() {
  // console.log("Wizzy top filters alldata", document.querySelectorAll('.stroller-category'));

  var quickFilter = window.quickFilters || '';
  var topFilterElements = document.querySelectorAll('.stroller-category');

  function normalizeQuickFilterValue(value) {
    return String(value || '').replace(/[\[\]"]/g, '').trim();
  }

  function findQuickFilterFacetItem(dataType, activeOnly) {
    var selector = `.wizzy-filters-facet-block.facet-block-${quickFilter} 
      .wizzy-facet-body.facet-body-${quickFilter} 
      .wizzy-facet-list-item${activeOnly ? '.active' : ''}`;

    return Array.from(document.querySelectorAll(selector)).find((item) => {
      return normalizeQuickFilterValue(item.title) === normalizeQuickFilterValue(dataType);
    });
  }

  function moveActiveTopFiltersFirst() {
    var wrappers = document.querySelectorAll('.wizzy-quick-filter-slides');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      var activeSlides = Array.from(wrapper.querySelectorAll('.stroller-category.active'));
      if (!activeSlides.length) return;

      activeSlides.reverse().forEach((slide) => {
        wrapper.insertBefore(slide, wrapper.firstElementChild);
      });

      var slider = wrapper.closest('.wizzy-quick-filter-slider');
      if (slider && slider.wizzyQuickFilterSwiper) {
        var swiperInstance = slider.wizzyQuickFilterSwiper;
        // Wait for DOM reorder to be flushed before Swiper recalculates
        requestAnimationFrame(function () {
          if (typeof swiperInstance.update === 'function') {
            swiperInstance.update();
          }
          if (typeof swiperInstance.slideTo === 'function') {
            swiperInstance.slideTo(0, 300);
          }
        });
      }
    });
  }

  topFilterElements.forEach((el) => {
    if (!el.classList.contains('wizzy-top-click-event-attached')) {
      el.addEventListener('click', function () {
        var dataType = this.getAttribute("data-type");

        // console.log("Wizzy top filters dataType", dataType);
        if (dataType && quickFilter) {
          var filterIsActive = findQuickFilterFacetItem(dataType, true);
          // if (filterIsActive) {
          //   filterIsActive.click();

          //   setTimeout(function () {
          //     var applyBtn = document.querySelector('.wizzy-apply-all-button');
          //     if (applyBtn) {
          //       applyBtn.click();
          //     }
          //     // console.log("Wizzy top filters applied", applyBtn);
          //   }, 100);
          // } else {
          // var allFilterElements = document.querySelectorAll(
          //   `.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block.facet-block-product_product_type_custom 
          //    .wizzy-facet-body.facet-body-product_product_type_custom 
          //    .wizzy-facet-list-item.active`
          // );

          // // console.log("Wizzy top filters allFilterElements", allFilterElements);
          // if (allFilterElements.length > 0) {
          //   allFilterElements.forEach((fE) => {
          //     fE.click();
          //   });
          // }

          // Track activation order: most recently clicked active filter goes first
          if (!window.wizzyQuickFilterClickOrder) window.wizzyQuickFilterClickOrder = [];
          if (filterIsActive) {
            // Deactivating — remove from order
            window.wizzyQuickFilterClickOrder = window.wizzyQuickFilterClickOrder.filter((t) => t !== dataType);
          } else {
            // Activating — add to front
            window.wizzyQuickFilterClickOrder = [
              dataType,
              ...window.wizzyQuickFilterClickOrder.filter((t) => t !== dataType)
            ];
          }

          var filterElement = findQuickFilterFacetItem(dataType, false);

          // console.log("Wizzy top filters filterElement", filterElement);
          if (filterElement) {
            // saveWizzyQuickFilterScrollPosition();
            filterElement.click();

            setTimeout(function () {
              var applyBtn = document.querySelector('.wizzy-apply-all-button');
              if (applyBtn) {
                applyBtn.click();
              }
              // console.log("Wizzy top filters applied", applyBtn);
            }, 100);
          }
          // }
        }
      });
      el.classList.add('wizzy-top-click-event-attached');
    }
  });

  // ── Sidebar facet click order tracking ──────────────────────────────────
  // When user selects a filter from the LEFT SIDEBAR (same facet as quickFilter),
  // update wizzyQuickFilterClickOrder so the quick-filter slider reorders correctly.
  // We only attach the listener — we do NOT change Wizzy's own toggle/apply logic.
  if (quickFilter) {
    var sidebarItems = document.querySelectorAll(
      '.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block.facet-block-' + quickFilter + ' ' +
      '.wizzy-facet-body.facet-body-' + quickFilter + ' .wizzy-facet-list-item'
    );

    sidebarItems.forEach(function (item) {
      if (item.classList.contains('wizzy-quick-filter-order-attached')) return;

      item.addEventListener('click', function () {
        var filterVal = normalizeQuickFilterValue(this.title || this.getAttribute('title') || '');
        if (!filterVal) return;

        if (!window.wizzyQuickFilterClickOrder) window.wizzyQuickFilterClickOrder = [];

        var isCurrentlyActive = this.classList.contains('active');
        if (isCurrentlyActive) {
          // Clicking an active item → it will be deactivated → remove from order
          window.wizzyQuickFilterClickOrder = window.wizzyQuickFilterClickOrder.filter(function (t) {
            return t !== filterVal;
          });
        } else {
          // Clicking an inactive item → it will be activated → add to front
          window.wizzyQuickFilterClickOrder = [filterVal].concat(
            window.wizzyQuickFilterClickOrder.filter(function (t) { return t !== filterVal; })
          );
        }
      });

      item.classList.add('wizzy-quick-filter-order-attached');
    });
  }
  // ────────────────────────────────────────────────────────────────────────


  topFilterElements.forEach((el) => {
    el.classList.remove('active');
  });

  var appliedQuickFilters = document.querySelectorAll(
    `.wizzy-search-filters-left-wrapper .wizzy-filters-facet-block.facet-block-${quickFilter} 
      .wizzy-facet-body.facet-body-${quickFilter} 
      .wizzy-facet-list-item.active`
  );

  appliedQuickFilters.forEach((filter) => {
    var filterVal = normalizeQuickFilterValue(filter.title);

    document.querySelectorAll('.stroller-category').forEach((topQuickFilterEle) => {
      if (normalizeQuickFilterValue(topQuickFilterEle.getAttribute('data-type')) === filterVal) {
        topQuickFilterEle.classList.add('active');
      }
    });
  });

  moveActiveTopFiltersFirst();
}

// Quick Filters Requirement - Custom Clear All button - 05-06-2026
function clearButtonOnNoResultPage() {
  const backButton = document.querySelector(".custom-back-button");

  if (!backButton) return;

  const currentUrl = new URL(window.location.href);
  const pathname = currentUrl.pathname;
  const hasQueryParams = currentUrl.search.length > 0;
  const backButtonText = backButton.querySelector('span');

  // Update button text
  if (pathname.includes("/collections/") && hasQueryParams) {
    backButtonText.textContent = "Clear All Filters";
    const emptyResultsContent = backButton.closest(".wizzy-empty-results-content");

    if (emptyResultsContent) {
      const heading = emptyResultsContent.querySelector("h2");

      if (heading) {
        heading.textContent = "We couldn't find any products that match your current filter combination.";
      }
    }
  } else {
    backButton.style.display = 'none';
  }

  // Handle click
  backButton.addEventListener("click", function () {
    if (pathname.includes("/collections/") && hasQueryParams) {
      window.location.href = window.location.origin + pathname;
    }
  });
}

function hasPacks(val) {
  return val.toLocaleLowerCase().includes("pack") ? val.slice(0, 2) : false;
}

// Boosting Collection Pages Sort Order Code Starts
$("body").on("click", ".wizzy-selected-facet-list-item", function (event) {
  if (realPage !== 1) {
    realPage = 1;
    setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
  }

});

$("body").on("click", ".wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-header .wizzy-filters-clear-all", function (event) {
  if (realPage !== 1) {
    realPage = 1; // Issue : Because reset click page 2 is passing after that real page is updating so to resolve this shift this code to here.
    setSessionNumber(WIZZY_REAL_PAGE_KEY, realPage);
  }

});

async function loadNextInStockBatchIfNeeded(collectionHandle, threshold = 50) {
  // Hard guards (cheap)
  if (
    !Array.isArray(window.inStockWizzyCollectionProductIdsNew) ||
    window.wizzyLazy.loading ||
    window.wizzyLazy.nextPageToLoad > window.wizzyLazy.totalPages
  ) {
    return;
  }

  console.log("WIZZY boosting loadNextInStockBatchIfNeeded", window.wizzyLazy);

  window.wizzyLazy.loading = true;

  try {
    const page = window.wizzyLazy.nextPageToLoad;

    const res = await fetch(
      `/collections/${collectionHandle}?page=${page}&section_id=wizzy-collection-batch`
    );
    console.log("WIZZY boosting loadNextInStockBatchIfNeeded res", res);

    if (!res.ok) throw new Error("Section fetch failed");

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const script = doc.querySelector("script[data-wizzy-batch]");
    if (!script) throw new Error("wizzy batch script not found");

    const data = JSON.parse(script.textContent);
    console.log("WIZZY boosting loadNextInStockBatchIfNeeded data", data);

    if (Array.isArray(data.inStockIds) && data.inStockIds.length > 0) {
      // ✅ APPEND to the SAME array
      window.inStockWizzyCollectionProductIdsNew.push(...data.inStockIds);
      window.wizzyLazy.nextPageToLoad += 1;
    } else {
      // No more in-stock products
      // boostingDone = true;
    }

  } catch (err) {
    console.error("Wizzy lazy batch load failed:", err);
  } finally {
    window.wizzyLazy.loading = false;
  }
}

function areStringArraysEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const setA = new Set(a);
  for (const val of b) {
    if (!setA.has(val)) return false;
  }
  return true;
}

function arePriceRangesEqual(a = [], b = []) {
  if (a.length !== b.length) return false;

  const normalize = arr =>
    arr
      .map(r => `${r.gte ?? ''}-${r.lte ?? ''}`)
      .sort();

  const na = normalize(a);
  const nb = normalize(b);

  return na.every((v, i) => v === nb[i]);
}

function areAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    const arrA = a[key];
    const arrB = b[key];

    if (arrA.length !== arrB.length) return false;

    const setA = new Set(arrA);
    for (const val of arrB) {
      if (!setA.has(val)) return false;
    }
  }

  return true;
}

function normalizeRange(range) {
  return JSON.stringify({
    gte: Number(range.gte),
    lte: Number(range.lte)
  });
}

function areRangeArraysEqual(arrA = [], arrB = []) {
  if (arrA.length !== arrB.length) return false;

  const normA = arrA.map(normalizeRange).sort();
  const normB = arrB.map(normalizeRange).sort();

  for (let i = 0; i < normA.length; i++) {
    if (normA[i] !== normB[i]) return false;
  }

  return true;
}

function areFloatAttributesEqual(a = {}, b = {}) {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!Array.isArray(b[key])) return false;

    if (!areRangeArraysEqual(a[key], b[key])) return false;
  }

  return true;
}

function hasFilterStateChanged(currentFilters) {
  if (!wizzyCachedFilters) return true;

  if (!areAttributesEqual(
    currentFilters.attributes || {},
    wizzyCachedFilters.attributes
  )) return true;

  if (!areFloatAttributesEqual(
    currentFilters.floatAttributes || {},
    wizzyCachedFilters.floatAttributes
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.brands || [],
    wizzyCachedFilters.brands
  )) return true;

  if (!arePriceRangesEqual(
    currentFilters.sellingPrice || [],
    wizzyCachedFilters.sellingPrice
  )) return true;

  if (!areStringArraysEqual(
    currentFilters.genders || [],
    wizzyCachedFilters.genders
  )) return true;

  return false;
}

function deepClone(obj) {
  if (typeof structuredClone === "function") {
    return structuredClone(obj);
  }
  return JSON.parse(JSON.stringify(obj));
}

function getSessionNumber(key, defaultValue = 0) {
  const val = sessionStorage.getItem(key);
  return val !== null ? Number(val) : defaultValue;
}

function setSessionNumber(key, value) {
  sessionStorage.setItem(key, String(value));
}

function getSessionString(key, defaultValue = null) {
  const val = sessionStorage.getItem(key);
  return val !== null ? val : defaultValue;
}

function setSessionString(key, value) {
  if (value === null || value === undefined) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
}

function setCachedFilters(filters) {
  sessionStorage.setItem(
    "wizzyCachedFilters",
    JSON.stringify(filters)
  );
}

function getCachedFilters() {
  try {
    return JSON.parse(
      sessionStorage.getItem("wizzyCachedFilters")
    ) || null;
  } catch {
    return null;
  }
}

function getSessionStringArray(key, defaultValue = []) {
  try {
    const val = sessionStorage.getItem(key);
    return val ? JSON.parse(val) : defaultValue;
  } catch {
    return defaultValue;
  }
}

function setSessionStringArray(key, array) {
  try {
    if (!Array.isArray(array)) return;
    sessionStorage.setItem(key, JSON.stringify(array));
  } catch {
    // silently ignore 
  }
}
// Boosting Collection Pages Sort Order Code Ends


setTimeout(function () {

  function initializeWishlist() {
    $(".wishlist-hero-custom-button").each(function (index, element) {
      let buttonInfo = {};

      buttonInfo['ButtonClassElement'] = "wishlist-hero-custom-button-" + $(element).attr('data-wlh-variantid');
      buttonInfo['ProductId'] = parseInt($(element).attr('data-wlh-variantid'));
      buttonInfo['ProductLink'] = $(element).attr('data-wlh-link');
      buttonInfo['ProductVariantId'] = parseInt($(element).attr('data-wlh-variantid'));
      buttonInfo['ProductPrice'] = parseInt($(element).attr('data-wlh-price'));
      buttonInfo['ProductTitle'] = $(element).attr('data-wlh-name');
      buttonInfo['ProductImage'] = $(element).attr('data-wlh-image');
      buttonInfo['ButtonMode'] = "icon_only";
      buttonInfo['WishlistHash'] = "RYQLDZNW6ltoKbpk";

      window.WishListHero_SDK.InitializeAddToWishListButton(buttonInfo);
    });
  }

  initializeWishlist();


  //   $('body').on('click','.wizzy-filters-close-button',(e)=>{
  //      $('.wizzy-filters-bg').click();
  // });
  // $(document).ready(function() {
  //     $(".wizzy-facet-head:first").addClass('wizzy-selected-facet');
  // });
}, 1000);
$(document).on("click", '.wizzy-search-filters-left-wrapper .wizzy-facet-head', function (e) {
  console.log("llll");
  $(".wizzy-facet-head").removeClass('wizzy-selected-facet');
  $(this).addClass('wizzy-selected-facet');
  $('.wizzy-facet-body').css('display', 'none');
  $('.wizzy-facet-head').find('.facet-head-right').css('content', 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' aria-hidden=\'true\' focusable=\'false\' role=\'presentation\' class=\'icon icon-caret\' viewBox=\'0 0 10 6\' width=\'11\' height=\'11\' %3E%3Cpath fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z\' fill=\'currentColor\'%3E%3C/path%3E%3C/svg%3E")');
  console.log($(this).text().trim().split(" ")[0].toLowerCase(), "koooo"); // Use .trim() to remove extra whitespace
  $(this).find('.facet-head-right').css('content', 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' aria-hidden=\'true\' focusable=\'false\' role=\'presentation\' class=\'icon icon-caret-up\' viewBox=\'0 0 10 6\' width=\'11\' height=\'11\' %3E%3Cpath fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M9.354 5.354a.5.5 0 01-.708 0L5 1.707l-3.646 3.647a.5.5 0 01-.708-.708l4-4a.5.5 0 01.708 0l4 4a.5.5 0 010 .708z\' fill=\'currentColor\'%3E%3C/path%3E%3C/svg%3E")');
  $(this).next('.wizzy-facet-body').css('display', 'block');
  //$(".wizzy-facet-body.facet-body-" + $(this).find('.wizzy-facet-title').text().trim().split(" ")[0].toLowerCase()).css('display', 'block');
  localStorage.setItem('activeFacet', $(this).find(".facet-head-title").text());
});

$('body').on('click', '.wizzy-filters-close-button', (e) => {
  $('.wizzy-filters-bg').click();
});
$(document).on('click', ' .wizzy-apply-all-button', (e) => {
  $('.wizzy-filters-bg').click();
  var activeFilterCount1 = 0;
  $(".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block").each((index, element) => {
    var activeFilterCount = $(element).find(".facet-count-title").text();
    var countAsInteger = parseInt(activeFilterCount, 10);
    if (!isNaN(countAsInteger)) {
      activeFilterCount1 += countAsInteger;
    }
  });
  if (activeFilterCount1 > 0) {
    $('.wizzy-filters-mobile-entry .wizzy-filter-mobile-count b').html(activeFilterCount1);
    $('.wizzy-sub-most-used-filters .wizzy-applied-filters-count-top').html('(' + activeFilterCount1 + ')');
  }
});
$(document).on('click', ' .wizzy-filter-active-custome', (e) => {
  $('.wizzy-facet-body').css('display', 'none');
  $("body").addClass("wizzy-overlay-opened wizzy-filters-overlay");
  $('.wizzy-search-filters-left-wrapper').css('left', '0px');
  $(".wizzy-facet-head").removeClass('wizzy-selected-facet');
  var dataOpenDrawer = $(this).data('open-drawer');
  $(".wizzy-facet-head").each(function (index) {
    if ($(this).hasClass("facet-head-colors")) {
      $(this).addClass('wizzy-selected-facet');
      $(this).next('.wizzy-facet-body').css('display', 'block');
    }
  });
});

$(document).on('click', '.swipe-to-change-done', () => {
  let swipecount = parseInt(localStorage.getItem('swipecount')) || 0;
  swipecount++;
  localStorage.setItem('swipecount', swipecount.toString());
  $(".swipe-to-change-done").eq(0).parents('.swipe-to-change').css('display', 'none');
});

//$(document).scroll(function() { 
// const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
// const leftfilterH = $('.wizzy-search-filters-left').height() - $('.section-header').height();
// const htmlH = $('.wizzy-search-wrapper').height();
// const footerH = $('.shopify-section-group-footer-group').height();
// const fotterminus = htmlH - footerH;
// //alert(htmlH);
// console.log('hell');
// console.log(scrollTop + 'hell' + fotterminus);
// if (scrollTop > leftfilterH && scrollTop < fotterminus) {
//   $('.wizzy-search-wrapper .wizzy-search-filters-left').css({"position": "fixed", "top": "auto", "bottom": "0"});
// } else if (scrollTop > fotterminus) {
//   $('.wizzy-search-wrapper .wizzy-search-filters-left').css({"position": "relative", "top": fotterminus, "bottom": "0"});
// } else {
//   // Handle other cases if needed
// }
//});


//viewSimilar
function viewSimilar(element) {
  //element.style.color = color;
  //$("body").addClass('hide-overflow-view');
  const url = element.getAttribute('data-handle');
  const sectionId = 'shopify-section-template--21239718772958__similar_products_popup_PY4tQt';

  fetch(url)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const element = doc.getElementById(sectionId);

      if (element) {
        // You have the element, now you can access its data or manipulate it
        console.log();
        $('.view-append').html(element.innerHTML);
        $('.similar-same-products').css('display', 'none'); // Initially hide the products
        $('.lod-padd').css('display', 'block');
        setTimeout(function () {
          $('.lod-padd').css('display', 'none'); // Remove loader class
          $('.similar-same-products').css('display', 'block'); // Show the products
        }, 1000);
      } else {
        console.error('Element not found');
      }
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
}

document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  var searchforms = document.querySelectorAll('search-form');
  // console.log("wiz searchforms", searchforms);
  searchforms.forEach((searchform) => {
    searchform.style.pointerEvents = 'auto';
  });
  var searchBars = document.querySelectorAll('search-form .search__input.field__input');
  var searchBarForMobile = document.querySelector('#searchInput');
  // console.log("WIZ SEARCHBARS", searchBars);

  function toggleAutocompleteClass() {
    const body = document.body;
    // console.log("WIZ LOGGED AUTOCOMPLETE");
    if (Array.from(searchBars).some(searchBar => document.activeElement === searchBar) || (document.activeElement === searchBarForMobile)) {
      body.classList.add('autocompleteOpened');
    } else {
      body.classList.remove('autocompleteOpened');
    }
  }

  searchBars.forEach(searchBar => {
    searchBar.addEventListener('focus', toggleAutocompleteClass);
    searchBar.addEventListener('blur', toggleAutocompleteClass);
  });

  if (window.innerWidth < 768) {


    if (searchBarForMobile) {
      searchBarForMobile.addEventListener('focus', toggleAutocompleteClass);
      searchBarForMobile.addEventListener('blur', toggleAutocompleteClass);
    }
  }
});


// Listen for the browser's back button click event
window.addEventListener('popstate', function (event) {
  console.log(window.location.href);
  if (!document.getElementById('MainContent').classList.contains('page-width')) {
    setTimeout(function () {
      document.getElementById('MainContent').classList.add('page-width');
    }, 2000);
  }
  if ((window.location.href === 'https://duckduckbaby.in/') || (window.location.href === 'https://duckduckbaby.in/?_ab=0&_fd=0&_sc=1')) {
    console.log(window.location.href);
    window.location.reload();
    if (document.getElementById('MainContent').classList.contains('page-width')) {
      setTimeout(function () {
        document.getElementById('MainContent').classList.remove('page-width');
        document.getElementById('MainContent').classList.remove('wizzy-main-content');
      }, 1000);
    }
  }

  if (window.location.href.startsWith('https://duckduckbaby.in/collections')) {
    // console.log("COLLECTION BACKED");
    window.location.reload();

    const breadcrumbsContainer = $(".breadcrumbs");
    breadcrumbsContainer.removeClass("hide");
    const bannerContainer = $(".collection-banner");
    bannerContainer.show();
    setTimeout(function () {
      $("main").removeClass("page-width");
    }, 3000);
    setTimeout(function () {
      $("#wizzy-shopify-collection-page-wrapper .wizzy-search-wrapper.wizzy-category-page").removeClass("mobileTapped");
    }, 500);
  }
  if ((window.location.href === 'https://duckduckbaby.in/apps/wishlists')) {
    console.log(window.location.href);
    window.location.reload();
    if (document.getElementById('MainContent').classList.contains('page-width')) {
      setTimeout(function () {
        document.getElementById('MainContent').classList.remove('page-width');
      }, 2000);
    }
  }
  if (window.location.href.startsWith('https://duckduckbaby.in/pages/search?q=')) {
    console.log(window.location.href);
    window.location.reload();
    setTimeout(function () {
      $("#MainContent").addClass("page-width");
    }, 1000);

  }
  if ((window.location.href.startsWith === 'https://duckduckbaby.in/products') || (window.location.href === 'https://duckduckbaby.in/cart')) {
    console.log(window.location.href);
    window.location.reload();
  }
});

// custom js

function getCookie(name) {
  var value = `; ${document.cookie}`;
  var parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

$(document).ready(function () {
  $(document).ready(function () {
    function handleAjaxRequest() {

      if (window.location.pathname.includes('/products/')) {
        fetchAndAppendWishlistIcons();
        appendWishlistIcons();
      }

      var productvariantsId = $("#mswishlistbutton").data("variant");
      // var productcustomerId = $('#mswishlistbutton').data('customerid');
      var productcustomerIds = $("#ms_customer_id").val();
      var store_name = Shopify.shop;

      //   console.log(productcustomerId);
      var uniqueId = $(".mswishlistbutton").data("unique-id");
      var wp_icon_change = "";

      if (productcustomerIds == "0") {
        var productcustomerId = "";
      } else {
        var productcustomerId = productcustomerIds;
      }
      var uniqueDeviceId = getCookie('new_unique_device_id');
      $.ajax({
        url: "https://wishlistapp.binaryic.in/geticon_color",
        method: "POST",
        data: {
          productvariantsId: productvariantsId,
          productcustomerId: productcustomerId,
          store_name: store_name,
          unique_device_id: uniqueDeviceId
        },
        success: function (response) {
          $("#wl_count").text(response.addwishdataCount);
          if (response.wishsettingdata.page_custom_css != null) {
            $("head").append("<style>" + response.wishsettingdata.page_custom_css + "</style>");
          }

          if (response.addproductCount > 0) {
            $("#wl_count").text(response.addwishdataCount);
            var wp_remove_icon_color = response.icondata.wishlist_icon_hover_color;
            $("#uniqueidcss" + uniqueId).css("color", wp_remove_icon_color);
          } else {
            if (response.addwishdataCount > 0) {
              $("#wl_count").text(response.addwishdataCount);
            } else {
              $("#wl_count").text(0);
            }
            var wp_add_icon_color = response.icondata.wishlist_icon_color;
            $("#uniqueidcss" + uniqueId).css("color", wp_add_icon_color);
          }

        },
        error: function (error) {
          //   alert(error); // Display an alert if there's an error
          console.error("Error fetching data:", error);
        },
      });
    }

    handleAjaxRequest();

    function fetchAndAppendWishlistIcons() {
      var uniqueDeviceId = getCookie('new_unique_device_id');
      var store_id = $("#mswishlistbutton").data("storeid");
      var customer_id = $("#ms_customer_id").val();
      var store_name = Shopify.shop;

      $.ajax({
        url: "https://wishlistapp.binaryic.in/getWishListProduct",
        method: "POST",
        data: {
          store_id: store_id,
          customer_id: customer_id,
          store_name: store_name,
          unique_device_id: uniqueDeviceId
        },
        success: function (response) {
          var wishlistProducts = response;
          localStorage.setItem("wishlistProducts", JSON.stringify(response));
          appendWishlistInProductDetails();
        },
      });
    }

    function appendWishlistInProductDetails() {
      var storedWishlistProducts = localStorage.getItem("wishlistProducts");
      var wishlistProducts = JSON.parse(storedWishlistProducts);
      // var wp_icon_change = "fa-heart-o";
      // var wp_icon = "fa-heart";
      $(".mswishlistbutton2").each(function () {
        var response = wishlistProducts;
        var icondata = response.icondata;
        var iconcolor = response.iconcolor.wishlist_icon_hover_color;
        var productIds = icondata.map((item) => item.product_id);
        var currentUniqueId = $(this).data("unique-id");
        var customerids = $("#ms_customer_id").val();
        var productId = $(this).data("product");
        var wp_icon = response.iconcolor.wishlist_icon;
        var wp_icon_change = response.iconcolor.wishlist_remove_icon;

        // if (customerids == 0) {
        //     $(".product-detail-wishlist-text").addClass("login_signup");
        // } else {
        //     $(".product-detail-wishlist-text").removeClass("login_signup");
        // }

        if (productIds.includes(productId.toString())) {
          var color = iconcolor;
          var wishlist_icon_text = response.iconcolor.add_to_wishlist;
          var code2 = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="${color}" style="height:20px;"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>`;

        } else {
          var wishlist_icon_text = response.iconcolor.remove_from_wishlist;
          var code2 = ` <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="#e77a50" style="height: 20px;"><path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg>`;

        }

        if (!$(this).find(".append-wishlist-btn-icon").length) {
          $(".append-wishlist-btn-icon").append(code2);
        }

        if (!$(this).find(".append-wishlist-sticky-btn-icon").length) {
          $(".append-wishlist-sticky-btn-icon").append(code2);
        }
      });
    }

    // appendWishlistInProductDetails();
  });

  $(document).on("click", "#mswishlistbutton", function () {
    event.preventDefault();
    $('.toast-oval toast-success').hide();
    toastr.clear();
    var button = this;
    button.disabled = true;
    var shopdomain = $(this).attr("data-storename");
    var store_id = $(this).attr("data-storeid");
    var customerids = $("#ms_customer_id").val();
    var productId = $(this).attr("data-product");
    var variantproductId = $(this).attr("data-variant");
    var uniqueId = $(this).attr("data-unique-id");
    var shopurl = Shopify.shop;

    var _this = this;

    function generateBrowserId() {
      var userAgent = navigator.userAgent.toLowerCase();
      var deviceType = "desktop";

      if (/mobile|android|iphone|ipad|ipod|windows phone/.test(userAgent)) {
        deviceType = "mobile";
      } else if (/tablet|ipad/.test(userAgent)) {
        deviceType = "tablet";
      }

      var randomId = Math.random().toString(36).substr(2, 9);
      var device_id = randomId + "-" + deviceType;

      document.cookie = "new_unique_device_id=" + device_id + "; path=/; max-age=" + (60 * 60 * 24 * 30); // 30 days expiry

      return device_id;
    }

    var uniqueDeviceId = getCookie('new_unique_device_id');
    if (!uniqueDeviceId) {
      uniqueDeviceId = generateBrowserId();
    }

    // if (customerids == "0") {
    //     var customerid = "";
    //   $(".product-detail-wishlist-text").addClass("login_signup");
    //     return false;
    // } else {
    //     var customerid = customerids;
    //    $(".product-detail-wishlist-text").removeClass("login_signup");
    // }

    $.ajax({
      type: "POST",
      url: "https://wishlistapp.binaryic.in/wishlist_bt",
      data: {
        product_id: productId,
        variant_id: variantproductId,
        shopurl: shopurl,
        customerid: customerids,
        shop_id: store_id,
        shop_name: shopdomain,
        unique_device_id: uniqueDeviceId,
      },
      success: function (response) {
        if (response && response.wl_page_setting_data && response.wl_page_setting_data.toastr_position) {
          var toastr_position = response.wl_page_setting_data.toastr_position;
        } else {
          var toastr_position = 'toast-top-right';
        }
        toastr.options = {
          closeButton: false,
          progressBar: true,
          preventDuplicates: true,
          showDuration: "3000",
          hideDuration: "1000",
          timeOut: "1000",
          positionClass: toastr_position,
          toastClass: "toast-oval",
        };
        if (response.wl_page_setting_data) {
          var toastr_background_color = response.wl_page_setting_data.toastr_background_color || '#000000';
          var toastr_text_color = response.wl_page_setting_data.toastr_text_color || '#ffffff';
          var toastr_width = response.wl_page_setting_data.toastr_width || '200px';
          var toastr_height = response.wl_page_setting_data.toastr_height || '0px';
          var toastr_font_size = response.wl_page_setting_data.toastr_font_size || '10px';
          var toastr_font_family = response.wl_page_setting_data.toastr_font_family || 'serif';

          var style = document.createElement('style');
          style.type = 'text/css';
          style.innerHTML = `
						   .toast-oval {
							   background-color: ${toastr_background_color} !important;
							   color: ${toastr_text_color} !important;
							   width: ${toastr_width} !important;
							   height: ${toastr_height} !important;
							   font-size: ${toastr_font_size} !important;
							   border-radius: 50px !important;
							   padding: 20px 40px !important;
							 font-family: ${toastr_font_family}!important;
							 opacity: 1 !important;
						   }
					   `;
          document.getElementsByTagName('head')[0].appendChild(style);
        }
        setTimeout(function () {
          toastr.clear();
        }, 1000);
        // $('.toast-oval toast-success').hide();
        // toastr.clear();
        toastr.success(response.toaster_message);

        var wp_add_icon_color = response.icondata.wishlist_icon_color;
        var wp_icon_hover_color = response.icondata.wishlist_icon_hover_color;
        let wishListIconTag = $(_this).find(".wishlistIcon");
        var wp_icon = response.icondata.wishlist_icon;
        var wp_remove_icon = response.icondata.wishlist_remove_icon;
        var wishlist_icon_text = response.icondata.add_to_wishlist;
        var wishlist_icon_remove_text = response.icondata.remove_from_wishlist;

        wishListIconTag.css("color", wp_add_icon_color);
        // $(_this).find(".wishlistIcon").removeClass(wp_remove_icon).addClass(wp_icon);
        // $(".wishlistIcon2").css("color", wp_icon_hover_color);
        // $(".wishlistIcon2").removeClass(wp_remove_icon).addClass(wp_icon);
        // $(".product-details-wishlist-text-change").text(wishlist_icon_text);
        $("#wl_count").text(response.addwishdataCount);

        if ($(_this).find(".wishlistDiv").length == 1) {
          var newSVGIcon = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="${wp_icon_hover_color}" style="height:20px;"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>`;
          // $(_this).find(".wishlistDiv").html(newSVGIcon);
          $(`#mswishlistbutton[data-product='${productId}']`).each(function () {
            $(this).find(".wishlistDiv").html(newSVGIcon);
          });
        } else {
          var pdpSVGIcon = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="${wp_icon_hover_color}" style="height:20px;"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                         <span style="font-size:18px;" class="product-details-wishlist-text-change">Wishlist</span>`;

          $(".append-wishlist-btn-icon").html(pdpSVGIcon);
          $(".append-wishlist-sticky-btn-icon").html(pdpSVGIcon);
          $(".product-details-wishlist-text-change").text(wishlist_icon_text);
          $(".append-wishlist-btn-icon").removeClass("load-btn");
          $(".append-wishlist-sticky-btn-icon").removeClass("load-btn");
        }

        if (response.wl_pro_delete == "1") {
          if (response.addwishdataCount > 0) {
            $("#wl_count").text(response.addwishdataCount);
          } else {
            $("#wl_count").text(0);
          }
          // $("#wl_count").text(response.addwishdataCount);
          var wp_add_icon_color = response.icondata.wishlist_icon_color;
          // $(_this).find(".wishlistIcon").removeClass(wp_icon).addClass(wp_remove_icon);
          // $(".wishlistIcon2").removeClass(wp_icon).addClass(wp_remove_icon).css("color", "");

          if ($(_this).find(".wishlistDiv").length == 1) {
            var newSVGIcon = `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x no-bg" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="#000000" style="height:20px;"><path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg>`;
            // $(_this).find(".wishlistDiv").html(newSVGIcon);
            $(`#mswishlistbutton[data-product='${productId}']`).each(function () {
              $(this).find(".wishlistDiv").html(newSVGIcon);
            });
          } else {
            var pdpSVGIcon = `<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="#e77a50" style="height:20px;"><path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg>
                                      <span style="font-size:18px;" class="product-details-wishlist-text-change">${wishlist_icon_text}</span>`;

            $(".append-wishlist-btn-icon").html(pdpSVGIcon);
            $(".append-wishlist-sticky-btn-icon").html(pdpSVGIcon);
            $(".product-details-wishlist-text-change").text(wishlist_icon_remove_text);
          }



        } else {
          var wp_remove_icon_color = response.icondata.wishlist_icon_hover_color;
          $("#wl_count").text(response.addwishdataCount);
          wishListIconTag.css("color", wp_remove_icon_color);
          $(".mswlbtn").css("background", wp_remove_icon_color);
          $(".mswlbtn").text(response.icondata.remove_from_wishlist);
          $(".mswlbtn").css({
            padding: "10px 20px",
            cursor: "pointer",
            width: "max-content",
            color: "white",
          });

        }
        setTimeout(function () {
          button.disabled = false;
        }, 1000);
      },
      error: function (error) {
        alert("Failed to add product to wishlistddd.");
        setTimeout(function () {
          button.disabled = false;
        }, 1000);
      },
    });
  });


  //move to wishlist
  $(document).ready(function () {
    $(".wishlist-move, .cart-wishlist-move").click(function (e) {
      var product_id = $(this).data("product");
      var variant_id = $(this).data("variant");
      var customer_id = $(this).data("customer");
      var store_id = $(this).data("store");
      var shop_name = $(this).data("shop_name");
      console.log("Product ID:", product_id);
      $.ajax({
        url: "https://wishlistapp.binaryic.in/moveToWishlistProduct",
        type: "POST",
        data: {
          product_id: product_id,
          variant_id: variant_id,
          customer_id: customer_id,
          store_id: store_id,
          shop_name: shop_name,
        },
        success: function (response) {
          $("#wl_count").text(response.addwishdataCount);
        },
        error: function (xhr, status, error) {
          console.error("AJAX error:", error);
        },
      });
    });
  });

  $(document).ready(function () {
    var loginId = $("#ms_customer_id").val();
    var store_name = Shopify.shop;
    var customerids = $("#ms_customer_id").val();
    var uniqueDeviceId = getCookie('new_unique_device_id');
    if (loginId != 0) {
      $.ajax({
        url: "https://wishlistapp.binaryic.in/login_get_Id",
        method: "POST",
        data: {
          loginId: loginId,
          store_name: store_name,
          customerids: customerids,
          unique_device_id: uniqueDeviceId
        },
        success: function (response) {
          console.log(response.addproductCount);
          $("#wl_count").text(response.addproductCount);
        },
        error: function (error) {
          console.error("Error fetching data:", error);
        },
      });
    }

  });

  // document.head.appendChild(script);
});




//viewSimilar
function appendWishlistIcons() {
  var store_id = $("#mswishlistbutton").data("storeid");
  var customer_id = $("#ms_customer_id").val();
  var store_name = Shopify.shop;
  var uniqueDeviceId = getCookie('new_unique_device_id');
  $.ajax({
    url: "https://wishlistapp.binaryic.in/getWishListProduct",
    method: "POST",
    data: {
      store_id: store_id,
      customer_id: customer_id,
      store_name: store_name,
      unique_device_id: uniqueDeviceId
    },
    success: function (response) {
      var wishlistProducts = response;
      localStorage.setItem("wishlistProducts", JSON.stringify(response));
      var storedWishlistProducts = localStorage.getItem("wishlistProducts");
      var wishlistProducts = JSON.parse(storedWishlistProducts);
      // console.log('responseee',wishlistProducts);
      // var wp_icon_change = "fa-heart-o";
      // var wp_icon = "fa-heart";
      $(".mswishlistbutton").each(function () {
        var response = wishlistProducts;
        var icondata = response.icondata;
        var iconcolor = response.iconcolor.wishlist_icon_hover_color;
        var productIds = icondata.map((item) => item.product_id);
        var currentUniqueId = $(this).data("unique-id");
        var customerids = $("#ms_customer_id").val();
        var wp_icon = response.iconcolor.wishlist_icon;
        var wp_icon_change = response.iconcolor.wishlist_remove_icon;
        color = response.iconcolor.wishlist_icon_color;
        if (productIds.includes(currentUniqueId.toString())) {
          var color = iconcolor;
          var code = `<div style="display: flex; align-items: center; gap: 10px; flex-direction: row-reverse; padding-right: 12px;padding-top: 6px;" class="wishlistDiv">
                                                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="${color}" style="height:20px;"><path fill="currentColor" d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>
                                            </div>`;
        } else {
          var code = `<div style="display: flex; align-items: center; gap: 10px; flex-direction: row-reverse; padding-right: 12px;padding-top: 6px;" class="wishlistDiv">
                                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" class="svg-inline--fa fa-heart fa-w-16 fa-1x no-bg" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" color="#000000" style="height: 20px;"><path fill="currentColor" d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"></path></svg>
                                            </div>`;
        }
        if (!$(this).find(".wishlistDiv").length) {
          $(this).append(code);
        }
      });
    },
  });
}

function viewSimilar(element) {
  const url = element.getAttribute("data-handle");
  const sectionId = "shopify-section-template--21239718772958__similar_products_popup_PY4tQt";


  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const element = doc.getElementById(sectionId);
      //var appended = false;
      if (element) {
        // You have the element, now you can access its data or manipulate it
        $(".view-append").html(element.innerHTML);
        $('.similar-same-products').css('display', 'none'); // Initially hide the products
        $('.lod-padd').css('display', 'block');
        setTimeout(function () {
          $('.lod-padd').css('display', 'none'); // Remove loader class
          $('.similar-same-products').css('display', 'block'); // Show the products
        }, 1000);
        appendWishlistIcons();
        //appended = true;
      } else {
        console.error("Element not found");
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
}

function updateScrollMarginTop() {
  var collectionMainContent = document.querySelector('.wizzy-main-content');

  // Reset for desktop
  if (window.innerWidth > 768 || !window.wizzyConfig?.common?.isOnCategoryPage) {
    return;
  }

  var collectionTitle = document.querySelector('#wizzy-collection-title-mob');

  if (!collectionTitle || !collectionMainContent) return;

  var divDistance =
    collectionMainContent.getBoundingClientRect().top -
    collectionTitle.getBoundingClientRect().top;

  divDistance = divDistance + 55;

  // console.log("Wizzy distance:", divDistance);

  var topSmartBannerDiv = document.querySelector('#smart-banner');

  if (topSmartBannerDiv) {
    var smartBannerHeight = topSmartBannerDiv.getBoundingClientRect()?.height;

    if (smartBannerHeight > 0) {
      divDistance = divDistance + smartBannerHeight;
    }
  }

  collectionMainContent.style.scrollMarginTop = `${divDistance}px`;
}

// Run on page load
document.addEventListener('DOMContentLoaded', updateScrollMarginTop);

// Run on window load (if elements are rendered later)
window.addEventListener('load', updateScrollMarginTop);

// Run on resize
window.addEventListener('resize', updateScrollMarginTop);
